// Generated by scripts/build-canonical.ts from src/data/source/*.json.
// Do not edit by hand — re-run the script to refresh. This is schema v2 (canonical items
// catalog) — it coexists with the legacy per-category files, it does not replace them yet.

import type { ObtainMethod } from "../schema/types";

export const OBTAIN_METHODS: ObtainMethod[] = [
  {
    "id": "anglerfish-obtain",
    "itemId": "anglerfish",
    "method": "FISHING",
    "requiredLevel": 2,
    "habitat": "Sea Fishing",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "GOLDEN",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "arctic-char-obtain",
    "itemId": "arctic-char",
    "method": "FISHING",
    "requiredLevel": 10,
    "habitat": "Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "atlantic-mackerel-obtain",
    "itemId": "atlantic-mackerel",
    "method": "FISHING",
    "requiredLevel": 5,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "atlantic-pygmy-octopus-obtain",
    "itemId": "atlantic-pygmy-octopus",
    "method": "FISHING",
    "requiredLevel": 2,
    "habitat": "Zephyr Sea",
    "locationIds": [
      "zephyr-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "atlantic-salmon-obtain",
    "itemId": "atlantic-salmon",
    "method": "FISHING",
    "requiredLevel": 3,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "barbel-obtain",
    "itemId": "barbel",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Shallow River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "beltfish-obtain",
    "itemId": "beltfish",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Zephyr Sea",
    "locationIds": [
      "zephyr-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "blackspot-seabream-obtain",
    "itemId": "blackspot-seabream",
    "method": "FISHING",
    "requiredLevel": 7,
    "habitat": "Zephyr Sea",
    "locationIds": [
      "zephyr-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "blue-european-crayfish-obtain",
    "itemId": "blue-european-crayfish",
    "method": "FISHING",
    "requiredLevel": 8,
    "habitat": "Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "bluefin-tuna-obtain",
    "itemId": "bluefin-tuna",
    "method": "FISHING",
    "requiredLevel": 9,
    "habitat": "Zephyr Sea",
    "locationIds": [
      "zephyr-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      100000,
      200000
    ]
  },
  {
    "id": "bluegill-obtain",
    "itemId": "bluegill",
    "method": "FISHING",
    "requiredLevel": 10,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "burbot-obtain",
    "itemId": "burbot",
    "method": "FISHING",
    "requiredLevel": 4,
    "habitat": "Tranquil River",
    "locationIds": [
      "tranquil-river"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      2000,
      20000
    ]
  },
  {
    "id": "butterfly-koi-obtain",
    "itemId": "butterfly-koi",
    "method": "FISHING",
    "requiredLevel": 4,
    "habitat": "Meadow Lake",
    "locationIds": [
      "meadow-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "chum-salmon-obtain",
    "itemId": "chum-salmon",
    "method": "FISHING",
    "requiredLevel": 6,
    "habitat": "Tranquil River",
    "locationIds": [
      "tranquil-river"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "clownfish-obtain",
    "itemId": "clownfish",
    "method": "FISHING",
    "requiredLevel": 3,
    "habitat": "Old Sea",
    "locationIds": [
      "old-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "common-barbel-obtain",
    "itemId": "common-barbel",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Shallow River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "NIGHT",
      "DAWN",
      "DAY",
      "DUSK"
    ],
    "shadowSize": null
  },
  {
    "id": "common-bleak-obtain",
    "itemId": "common-bleak",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Lake",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "common-carp-obtain",
    "itemId": "common-carp",
    "method": "FISHING",
    "requiredLevel": 4,
    "habitat": "Rosy River",
    "locationIds": [
      "rosy-river"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "common-chub-obtain",
    "itemId": "common-chub",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Lake",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "common-octopus-obtain",
    "itemId": "common-octopus",
    "method": "FISHING",
    "requiredLevel": 2,
    "habitat": "Sea Fishing",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "common-prawn-obtain",
    "itemId": "common-prawn",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "common-rudd-obtain",
    "itemId": "common-rudd",
    "method": "FISHING",
    "requiredLevel": 5,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "common-shrimp-obtain",
    "itemId": "common-shrimp",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "NIGHT",
      "DAWN",
      "DAY",
      "DUSK"
    ],
    "shadowSize": null
  },
  {
    "id": "common-whitefish-obtain",
    "itemId": "common-whitefish",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "crucian-carp-obtain",
    "itemId": "crucian-carp",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "director-common-octopus-w-cinnamon-hat-obtain",
    "itemId": "director-common-octopus-w-cinnamon-hat",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      3829,
      2843,
      1939,
      1163,
      226
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "director-pygmy-octopus-w-brown-hat-obtain",
    "itemId": "director-pygmy-octopus-w-brown-hat",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3829,
      2843,
      1939,
      1163,
      226
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "director-pygmy-octopus-w-cyan-hat-obtain",
    "itemId": "director-pygmy-octopus-w-cyan-hat",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3791,
      2843,
      1939,
      1163,
      264
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "director-pygmy-octopus-w-navy-hat-obtain",
    "itemId": "director-pygmy-octopus-w-navy-hat",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3829,
      2843,
      1939,
      1163,
      226
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "edible-frog-obtain",
    "itemId": "edible-frog",
    "method": "FISHING",
    "requiredLevel": 3,
    "habitat": "Lake",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "european-crayfish-obtain",
    "itemId": "european-crayfish",
    "method": "FISHING",
    "requiredLevel": 3,
    "habitat": "Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "european-eel-obtain",
    "itemId": "european-eel",
    "method": "FISHING",
    "requiredLevel": 7,
    "habitat": "Old Sea",
    "locationIds": [
      "old-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "european-flying-squid-obtain",
    "itemId": "european-flying-squid",
    "method": "FISHING",
    "requiredLevel": 5,
    "habitat": "Sea Fishing",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "GOLDEN",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "european-lobster-obtain",
    "itemId": "european-lobster",
    "method": "FISHING",
    "requiredLevel": 5,
    "habitat": "Zephyr Sea",
    "locationIds": [
      "zephyr-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "european-mudminnow-obtain",
    "itemId": "european-mudminnow",
    "method": "FISHING",
    "requiredLevel": 8,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAWN",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "european-perch-obtain",
    "itemId": "european-perch",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "european-plaice-obtain",
    "itemId": "european-plaice",
    "method": "FISHING",
    "requiredLevel": 4,
    "habitat": "Old Sea",
    "locationIds": [
      "old-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "european-smelt-obtain",
    "itemId": "european-smelt",
    "method": "FISHING",
    "requiredLevel": 2,
    "habitat": "Meadow Lake",
    "locationIds": [
      "meadow-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "false-scad-obtain",
    "itemId": "false-scad",
    "method": "FISHING",
    "requiredLevel": 2,
    "habitat": "Zephyr Sea",
    "locationIds": [
      "zephyr-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "freshwater-blenny-obtain",
    "itemId": "freshwater-blenny",
    "method": "FISHING",
    "requiredLevel": 5,
    "habitat": "Rosy River",
    "locationIds": [
      "rosy-river"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "frostspore-king-crab-obtain",
    "itemId": "frostspore-king-crab",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Frostspore Fish",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "frostspore-fish",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "frostspore-ocean-sunfish-obtain",
    "itemId": "frostspore-ocean-sunfish",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Frostspore Fish",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "frostspore-fish",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "frostspore-puffer-fish-obtain",
    "itemId": "frostspore-puffer-fish",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Frostspore Fish",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "frostspore-fish",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "frostspore-seahorse-obtain",
    "itemId": "frostspore-seahorse",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Frostspore Fish",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "frostspore-fish",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "frostspore-whale-shark-obtain",
    "itemId": "frostspore-whale-shark",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Frostspore Fish",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "frostspore-fish",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      3791,
      2843,
      1939,
      1163,
      264
    ],
    "weightRange": [
      50000,
      200000
    ]
  },
  {
    "id": "giant-oarfish-obtain",
    "itemId": "giant-oarfish",
    "method": "FISHING",
    "requiredLevel": 7,
    "habitat": "Sea Fishing",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN"
    ],
    "shadowSize": "GOLDEN",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      100000,
      200000
    ]
  },
  {
    "id": "goby-obtain",
    "itemId": "goby",
    "method": "FISHING",
    "requiredLevel": 4,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      100,
      300
    ]
  },
  {
    "id": "golden-king-crab-obtain",
    "itemId": "golden-king-crab",
    "method": "FISHING",
    "requiredLevel": 8,
    "habitat": "Sea Fishing",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "GOLDEN",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      5000,
      20000
    ]
  },
  {
    "id": "goldfish-obtain",
    "itemId": "goldfish",
    "method": "FISHING",
    "requiredLevel": 8,
    "habitat": "Meadow Lake",
    "locationIds": [
      "meadow-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "grayling-obtain",
    "itemId": "grayling",
    "method": "FISHING",
    "requiredLevel": 6,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "haddock-obtain",
    "itemId": "haddock",
    "method": "FISHING",
    "requiredLevel": 8,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "hermit-crab-obtain",
    "itemId": "hermit-crab",
    "method": "FISHING",
    "requiredLevel": 3,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "horse-mackerel-obtain",
    "itemId": "horse-mackerel",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "sea",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL"
  },
  {
    "id": "huchen-obtain",
    "itemId": "huchen",
    "method": "FISHING",
    "requiredLevel": 9,
    "habitat": "Giantwood River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "king-crab-obtain",
    "itemId": "king-crab",
    "method": "FISHING",
    "requiredLevel": 8,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "large-pearl-mussel-obtain",
    "itemId": "large-pearl-mussel",
    "method": "FISHING",
    "requiredLevel": 6,
    "habitat": "Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "largemouth-bass-obtain",
    "itemId": "largemouth-bass",
    "method": "FISHING",
    "requiredLevel": 2,
    "habitat": "Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "mediterranean-killifish-obtain",
    "itemId": "mediterranean-killifish",
    "method": "FISHING",
    "requiredLevel": 7,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "minnow-obtain",
    "itemId": "minnow",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Tranquil River",
    "locationIds": [
      "tranquil-river"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "moonfish-obtain",
    "itemId": "moonfish",
    "method": "FISHING",
    "requiredLevel": 9,
    "habitat": "Sea Fishing",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "GOLDEN",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "mottled-sculpin-obtain",
    "itemId": "mottled-sculpin",
    "method": "FISHING",
    "requiredLevel": 7,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "mud-sunfish-obtain",
    "itemId": "mud-sunfish",
    "method": "FISHING",
    "requiredLevel": 3,
    "habitat": "Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "mussel-obtain",
    "itemId": "mussel",
    "method": "FISHING",
    "requiredLevel": 4,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "northern-pike-obtain",
    "itemId": "northern-pike",
    "method": "FISHING",
    "requiredLevel": 9,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "nursehound-obtain",
    "itemId": "nursehound",
    "method": "FISHING",
    "requiredLevel": 6,
    "habitat": "Sea Fishing",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "ocean-sunfish-obtain",
    "itemId": "ocean-sunfish",
    "method": "FISHING",
    "requiredLevel": 9,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "oriental-shrimp-obtain",
    "itemId": "oriental-shrimp",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "puffer-fish-obtain",
    "itemId": "puffer-fish",
    "method": "FISHING",
    "requiredLevel": 6,
    "habitat": "Old Sea",
    "locationIds": [
      "old-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "pumpkinseed-obtain",
    "itemId": "pumpkinseed",
    "method": "FISHING",
    "requiredLevel": 9,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "rabbit-fish-obtain",
    "itemId": "rabbit-fish",
    "method": "FISHING",
    "requiredLevel": 4,
    "habitat": "Ocean",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "red-bellied-piranha-obtain",
    "itemId": "red-bellied-piranha",
    "method": "FISHING",
    "requiredLevel": 4,
    "habitat": "Giantwood River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "river-crab-obtain",
    "itemId": "river-crab",
    "method": "FISHING",
    "requiredLevel": 4,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "ruffe-obtain",
    "itemId": "ruffe",
    "method": "FISHING",
    "requiredLevel": 3,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "sardine-obtain",
    "itemId": "sardine",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Ocean",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "scad-obtain",
    "itemId": "scad",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "schneider-obtain",
    "itemId": "schneider",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "sea-bass-obtain",
    "itemId": "sea-bass",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Ocean",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "sea-stickleback-obtain",
    "itemId": "sea-stickleback",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Old Sea",
    "locationIds": [
      "old-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "seahorse-obtain",
    "itemId": "seahorse",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "shortfin-mako-shark-obtain",
    "itemId": "shortfin-mako-shark",
    "method": "FISHING",
    "requiredLevel": 10,
    "habitat": "Sea Fishing",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN"
    ],
    "shadowSize": "GOLDEN",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "skipjack-tuna-obtain",
    "itemId": "skipjack-tuna",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Ocean",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "smooth-hammerhead-obtain",
    "itemId": "smooth-hammerhead",
    "method": "FISHING",
    "requiredLevel": 10,
    "habitat": "Old Sea",
    "locationIds": [
      "old-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "spined-loach-obtain",
    "itemId": "spined-loach",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Giantwood River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      100,
      400
    ]
  },
  {
    "id": "stone-loach-obtain",
    "itemId": "stone-loach",
    "method": "FISHING",
    "requiredLevel": 2,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "streber-obtain",
    "itemId": "streber",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Rosy River",
    "locationIds": [
      "rosy-river"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      1000,
      2000
    ]
  },
  {
    "id": "striped-red-mullet-obtain",
    "itemId": "striped-red-mullet",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Sea Fishing",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "GOLDEN",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      5000,
      20000
    ]
  },
  {
    "id": "swordfish-obtain",
    "itemId": "swordfish",
    "method": "FISHING",
    "requiredLevel": 10,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "tadpole-obtain",
    "itemId": "tadpole",
    "method": "FISHING",
    "requiredLevel": 4,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "tench-obtain",
    "itemId": "tench",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "three-spined-stickleback-obtain",
    "itemId": "three-spined-stickleback",
    "method": "FISHING",
    "requiredLevel": 7,
    "habitat": "Shallow River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "tilapia-obtain",
    "itemId": "tilapia",
    "method": "FISHING",
    "requiredLevel": 3,
    "habitat": "River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "trout-obtain",
    "itemId": "trout",
    "method": "FISHING",
    "requiredLevel": 5,
    "habitat": "Meadow Lake",
    "locationIds": [
      "meadow-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "tub-gurnard-obtain",
    "itemId": "tub-gurnard",
    "method": "FISHING",
    "requiredLevel": 6,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "turbot-obtain",
    "itemId": "turbot",
    "method": "FISHING",
    "requiredLevel": 2,
    "habitat": "Sea Fishing",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "wels-catfish-obtain",
    "itemId": "wels-catfish",
    "method": "FISHING",
    "requiredLevel": 10,
    "habitat": "Meadow Lake",
    "locationIds": [
      "meadow-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      50000,
      200000
    ]
  },
  {
    "id": "zander-obtain",
    "itemId": "zander",
    "method": "FISHING",
    "requiredLevel": 3,
    "habitat": "Giantwood River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "alpine-longhorn-beetle-obtain",
    "itemId": "alpine-longhorn-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 5,
    "habitat": "Forest Island",
    "locationIds": [
      "forest-island"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "amethyst-flower-beetle-obtain",
    "itemId": "amethyst-flower-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 2,
    "habitat": "Residential Area",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "ant-obtain",
    "itemId": "ant",
    "method": "BUG_CATCHING",
    "requiredLevel": 3,
    "habitat": "Fishing Village Square East Pier of Fishing Village",
    "locationIds": [
      "fishing_village",
      "fishing-village-square"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "apollo-obtain",
    "itemId": "apollo",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Bait the Insects",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "bait-the-insects",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ]
  },
  {
    "id": "asian-lady-beetle-obtain",
    "itemId": "asian-lady-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 5,
    "habitat": "Deer Tower",
    "locationIds": [
      "deer-tower"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "asparagus-beetle-obtain",
    "itemId": "asparagus-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ]
  },
  {
    "id": "bagworm-moth-obtain",
    "itemId": "bagworm-moth",
    "method": "BUG_CATCHING",
    "requiredLevel": 10,
    "habitat": "Deer Tower",
    "locationIds": [
      "deer-tower"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "beautiful-demoiselle-obtain",
    "itemId": "beautiful-demoiselle",
    "method": "BUG_CATCHING",
    "requiredLevel": 6,
    "habitat": "Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "beautiful-leopard-obtain",
    "itemId": "beautiful-leopard",
    "method": "BUG_CATCHING",
    "requiredLevel": 4,
    "habitat": "Wharf",
    "locationIds": [
      "wharf"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "blue-morpho-obtain",
    "itemId": "blue-morpho",
    "method": "BUG_CATCHING",
    "requiredLevel": 7,
    "habitat": "Spirit-Oak Pine Forest",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "blue-shieldbug-obtain",
    "itemId": "blue-shieldbug",
    "method": "BUG_CATCHING",
    "requiredLevel": 6,
    "habitat": "Lighthouse",
    "locationIds": [
      "lighthouse"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "bumblebee-obtain",
    "itemId": "bumblebee",
    "method": "BUG_CATCHING",
    "requiredLevel": 2,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "cabbage-white-obtain",
    "itemId": "cabbage-white",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Fishing Village Square East Pier of Fishing Village",
    "locationIds": [
      "fishing_village",
      "fishing-village-square"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ]
  },
  {
    "id": "cerulean-carpenter-obtain",
    "itemId": "cerulean-carpenter",
    "method": "BUG_CATCHING",
    "requiredLevel": 9,
    "habitat": "Fishing Village Square",
    "locationIds": [
      "fishing_village",
      "fishing-village-square"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "chestnut-tiger-obtain",
    "itemId": "chestnut-tiger",
    "method": "BUG_CATCHING",
    "requiredLevel": 7,
    "habitat": "Bait the Insects",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "bait-the-insects",
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "cicada-obtain",
    "itemId": "cicada",
    "method": "BUG_CATCHING",
    "requiredLevel": 4,
    "habitat": "Spirit-Oak Pine Forest",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "comet-moth-obtain",
    "itemId": "comet-moth",
    "method": "BUG_CATCHING",
    "requiredLevel": 8,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "common-blue-butterfly-obtain",
    "itemId": "common-blue-butterfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 2,
    "habitat": "Central Square Art Street Garden Street Residential Street",
    "locationIds": [
      "art-street",
      "central-square",
      "garden-street",
      "residential-street"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "common-brimstone-obtain",
    "itemId": "common-brimstone",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ]
  },
  {
    "id": "common-whitetail-obtain",
    "itemId": "common-whitetail",
    "method": "BUG_CATCHING",
    "requiredLevel": 4,
    "habitat": "River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "conehead-mantis-obtain",
    "itemId": "conehead-mantis",
    "method": "BUG_CATCHING",
    "requiredLevel": 9,
    "habitat": "Ruins",
    "locationIds": [
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "crimson-marsh-glider-obtain",
    "itemId": "crimson-marsh-glider",
    "method": "BUG_CATCHING",
    "requiredLevel": 7,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "elegant-flower-beetle-obtain",
    "itemId": "elegant-flower-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 7,
    "habitat": "Whale Mountain",
    "locationIds": [
      "whale-mountain"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "european-firebug-obtain",
    "itemId": "european-firebug",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Residential Area",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ]
  },
  {
    "id": "fire-colored-beetle-obtain",
    "itemId": "fire-colored-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 3,
    "habitat": "Onsen Onsen Mountain Lake Crater Lake Ruins",
    "locationIds": [
      "crater-lake",
      "onsen-mountain",
      "onsen-mountain-lake",
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "four-spotted-ladybug-obtain",
    "itemId": "four-spotted-ladybug",
    "method": "BUG_CATCHING",
    "requiredLevel": 4,
    "habitat": "Crater Lake",
    "locationIds": [
      "crater-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "four-spotted-skimmer-obtain",
    "itemId": "four-spotted-skimmer",
    "method": "BUG_CATCHING",
    "requiredLevel": 2,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "frostspore-mother-of-pearl-obtain",
    "itemId": "frostspore-mother-of-pearl",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Frostspore Butterfly Spirit-Oak Pine Forest Forest Jump Puzzle",
    "locationIds": [
      "jump-puzzle"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "frostspore-butterfly-spirit-oak-pine-forest-forest-jump-puzzle",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "frostspore-postman-butterfly-obtain",
    "itemId": "frostspore-postman-butterfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Frostspore Butterfly",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "frostspore-butterfly",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4930,
      2800,
      1500,
      450,
      320
    ]
  },
  {
    "id": "frostspore-purple-spotted-swallowtail-obtain",
    "itemId": "frostspore-purple-spotted-swallowtail",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Frostspore Butterfly Spirit-Oak Pine Forest",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "frostspore-butterfly-spirit-oak-pine-forest",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "frostspore-queen-alexandras-birdwing-obtain",
    "itemId": "frostspore-queen-alexandras-birdwing",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Frostspore Butterfly Deer Tower",
    "locationIds": [
      "deer-tower"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "frostspore-butterfly-deer-tower",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "frostspore-sulkowskys-morpho-obtain",
    "itemId": "frostspore-sulkowskys-morpho",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Frostspore Butterfly",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "frostspore-butterfly",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "giant-asian-mantis-obtain",
    "itemId": "giant-asian-mantis",
    "method": "BUG_CATCHING",
    "requiredLevel": 5,
    "habitat": "Ruins",
    "locationIds": [
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "gold-grasshopper-obtain",
    "itemId": "gold-grasshopper",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ]
  },
  {
    "id": "golden-jewel-scarab-obtain",
    "itemId": "golden-jewel-scarab",
    "method": "BUG_CATCHING",
    "requiredLevel": 7,
    "habitat": "Forest Jump Puzzle",
    "locationIds": [
      "jump-puzzle"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "golden-stag-beetle-obtain",
    "itemId": "golden-stag-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 9,
    "habitat": "Spirit-Oak Pine Forest",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "green-birdwing-obtain",
    "itemId": "green-birdwing",
    "method": "BUG_CATCHING",
    "requiredLevel": 6,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "green-script-supervisor-bumblebee-obtain",
    "itemId": "green-script-supervisor-bumblebee",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": "Amethyst Beach",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "green-tiger-beetle-obtain",
    "itemId": "green-tiger-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 2,
    "habitat": "Onsen Onsen Mountain Lake Crater Lake Ruins",
    "locationIds": [
      "crater-lake",
      "onsen-mountain",
      "onsen-mountain-lake",
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "hercules-beetle-obtain",
    "itemId": "hercules-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 10,
    "habitat": "Forest Deer Tower",
    "locationIds": [
      "deer-tower"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "horned-beetle-obtain",
    "itemId": "horned-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 8,
    "habitat": "East Pier of Fishing Village",
    "locationIds": [
      "fishing_village"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "katydid-obtain",
    "itemId": "katydid",
    "method": "BUG_CATCHING",
    "requiredLevel": 3,
    "habitat": "Amethyst Beach",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "large-banded-grasshopper-obtain",
    "itemId": "large-banded-grasshopper",
    "method": "BUG_CATCHING",
    "requiredLevel": 4,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "large-red-damselfly-obtain",
    "itemId": "large-red-damselfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Lake River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ]
  },
  {
    "id": "mediterranean-mantis-obtain",
    "itemId": "mediterranean-mantis",
    "method": "BUG_CATCHING",
    "requiredLevel": 4,
    "habitat": "Stone Cliff",
    "locationIds": [
      "stone-cliff"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "mini-moon-moth-obtain",
    "itemId": "mini-moon-moth",
    "method": "BUG_CATCHING",
    "requiredLevel": 3,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "minotaur-beetle-obtain",
    "itemId": "minotaur-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 7,
    "habitat": "Ruins",
    "locationIds": [
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "NIGHT"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "morpho-helena-obtain",
    "itemId": "morpho-helena",
    "method": "BUG_CATCHING",
    "requiredLevel": 10,
    "habitat": "Amethyst Beach",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "mother-of-pearl-obtain",
    "itemId": "mother-of-pearl",
    "method": "BUG_CATCHING",
    "requiredLevel": 9,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "NIGHT"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "mourning-cloak-obtain",
    "itemId": "mourning-cloak",
    "method": "BUG_CATCHING",
    "requiredLevel": 5,
    "habitat": "Onsen",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "old-world-swallowtail-obtain",
    "itemId": "old-world-swallowtail",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Spirit-Oak Pine Forest Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ]
  },
  {
    "id": "orange-tip-obtain",
    "itemId": "orange-tip",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Central Square",
    "locationIds": [
      "central-square"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ]
  },
  {
    "id": "peacock-butterfly-obtain",
    "itemId": "peacock-butterfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 5,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "picasso-bug-obtain",
    "itemId": "picasso-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": 8,
    "habitat": "Amethyst Beach",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "pink-katydid-obtain",
    "itemId": "pink-katydid",
    "method": "BUG_CATCHING",
    "requiredLevel": 3,
    "habitat": "Bait the Insects",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "bait-the-insects",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "pink-script-supervisor-bumblebee-obtain",
    "itemId": "pink-script-supervisor-bumblebee",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "postman-butterfly-obtain",
    "itemId": "postman-butterfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Bait the Insects",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "bait-the-insects",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      3000,
      1500,
      300,
      200
    ]
  },
  {
    "id": "purple-emperor-obtain",
    "itemId": "purple-emperor",
    "method": "BUG_CATCHING",
    "requiredLevel": 3,
    "habitat": "Whale Mountain",
    "locationIds": [
      "whale-mountain"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "purple-script-supervisor-bumblebee-obtain",
    "itemId": "purple-script-supervisor-bumblebee",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "rainbow-stag-beetle-obtain",
    "itemId": "rainbow-stag-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 9,
    "habitat": "Bait the Insects Ruins",
    "locationIds": [
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "bait-the-insects-ruins",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "rajah-brookes-birdwing-obtain",
    "itemId": "rajah-brookes-birdwing",
    "method": "BUG_CATCHING",
    "requiredLevel": 3,
    "habitat": "Residential Area",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "red-script-supervisor-bumblebee-obtain",
    "itemId": "red-script-supervisor-bumblebee",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": "Whale Mountain",
    "locationIds": [
      "whale-mountain"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "seven-spotted-ladybug-obtain",
    "itemId": "seven-spotted-ladybug",
    "method": "BUG_CATCHING",
    "requiredLevel": 2,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "siberian-grasshopper-obtain",
    "itemId": "siberian-grasshopper",
    "method": "BUG_CATCHING",
    "requiredLevel": 2,
    "habitat": "Fishing Village Square East Pier of Fishing Village",
    "locationIds": [
      "fishing_village",
      "fishing-village-square"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "silver-jewel-scarab-obtain",
    "itemId": "silver-jewel-scarab",
    "method": "BUG_CATCHING",
    "requiredLevel": 6,
    "habitat": "Stone Cliff",
    "locationIds": [
      "stone-cliff"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "spanish-moon-moth-obtain",
    "itemId": "spanish-moon-moth",
    "method": "BUG_CATCHING",
    "requiredLevel": 8,
    "habitat": "Spirit-Oak Pine Forest",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "splay-footed-carpenter-obtain",
    "itemId": "splay-footed-carpenter",
    "method": "BUG_CATCHING",
    "requiredLevel": 5,
    "habitat": "Whale Mountain",
    "locationIds": [
      "whale-mountain"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "stag-beetle-obtain",
    "itemId": "stag-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 6,
    "habitat": "Forest Jump Puzzle",
    "locationIds": [
      "jump-puzzle"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK"
    ],
    "starWeights": [
      4800,
      2200,
      1500,
      900,
      600
    ]
  },
  {
    "id": "sulkowskys-morpho-obtain",
    "itemId": "sulkowskys-morpho",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": "Inflatable Insect Attractor",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "sunset-morpho-obtain",
    "itemId": "sunset-morpho",
    "method": "BUG_CATCHING",
    "requiredLevel": 10,
    "habitat": "Forest Deer Tower",
    "locationIds": [
      "deer-tower"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "waroona-cuckoo-bee-obtain",
    "itemId": "waroona-cuckoo-bee",
    "method": "BUG_CATCHING",
    "requiredLevel": 3,
    "habitat": "Deer Tower",
    "locationIds": [
      "deer-tower"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "wasp-beetle-obtain",
    "itemId": "wasp-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 2,
    "habitat": "Spirit-Oak Pine Forest Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "white-witch-obtain",
    "itemId": "white-witch",
    "method": "BUG_CATCHING",
    "requiredLevel": 5,
    "habitat": "Bait the Insects",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "bait-the-insects",
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "african-olive-pigeon-obtain",
    "itemId": "african-olive-pigeon",
    "method": "BIRDWATCHING",
    "requiredLevel": 5,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "american-flamingo-obtain",
    "itemId": "american-flamingo",
    "method": "BIRDWATCHING",
    "requiredLevel": 9,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY"
    ]
  },
  {
    "id": "amur-falcon-obtain",
    "itemId": "amur-falcon",
    "method": "BIRDWATCHING",
    "requiredLevel": 10,
    "habitat": "Ruins",
    "locationIds": [
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "audouins-gull-obtain",
    "itemId": "audouins-gull",
    "method": "BIRDWATCHING",
    "requiredLevel": 3,
    "habitat": "Whale Sea",
    "locationIds": [
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "azores-bullfinch-obtain",
    "itemId": "azores-bullfinch",
    "method": "BIRDWATCHING",
    "requiredLevel": 10,
    "habitat": "East Pier of Fishing Village",
    "locationIds": [
      "fishing_village"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "azure-tit-obtain",
    "itemId": "azure-tit",
    "method": "BIRDWATCHING",
    "requiredLevel": 7,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "bearded-reedling-obtain",
    "itemId": "bearded-reedling",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Onsen Onsen Mountain Lake Crater Lake Ruins",
    "locationIds": [
      "crater-lake",
      "onsen-mountain",
      "onsen-mountain-lake",
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "blue-and-yellow-macaw-obtain",
    "itemId": "blue-and-yellow-macaw",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Nest of Hundreds",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "nest-of-hundreds",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "blue-peafowl-obtain",
    "itemId": "blue-peafowl",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Nest of Hundreds",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "nest-of-hundreds",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "brown-noddy-obtain",
    "itemId": "brown-noddy",
    "method": "BIRDWATCHING",
    "requiredLevel": 5,
    "habitat": "Old Sea",
    "locationIds": [
      "old-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "cinnamon-ground-dove-obtain",
    "itemId": "cinnamon-ground-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 6,
    "habitat": "Fishing Village Square",
    "locationIds": [
      "fishing_village",
      "fishing-village-square"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "common-kestrel-obtain",
    "itemId": "common-kestrel",
    "method": "BIRDWATCHING",
    "requiredLevel": 7,
    "habitat": "Deer Tower",
    "locationIds": [
      "deer-tower"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "double-barred-finch-obtain",
    "itemId": "double-barred-finch",
    "method": "BIRDWATCHING",
    "requiredLevel": 3,
    "habitat": "East Pier of Fishing Village",
    "locationIds": [
      "fishing_village"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "eagle-owl-obtain",
    "itemId": "eagle-owl",
    "method": "BIRDWATCHING",
    "requiredLevel": 10,
    "habitat": "Deer Tower",
    "locationIds": [
      "deer-tower"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "eastern-bluebird-obtain",
    "itemId": "eastern-bluebird",
    "method": "BIRDWATCHING",
    "requiredLevel": 8,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "eurasian-bullfinch-obtain",
    "itemId": "eurasian-bullfinch",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "eurasian-chaffinch-obtain",
    "itemId": "eurasian-chaffinch",
    "method": "BIRDWATCHING",
    "requiredLevel": 2,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "eurasian-collared-dove-obtain",
    "itemId": "eurasian-collared-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Residential Area",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "eurasian-golden-oriole-obtain",
    "itemId": "eurasian-golden-oriole",
    "method": "BIRDWATCHING",
    "requiredLevel": 3,
    "habitat": "Rosy River",
    "locationIds": [
      "rosy-river"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "eurasian-nuthatch-obtain",
    "itemId": "eurasian-nuthatch",
    "method": "BIRDWATCHING",
    "requiredLevel": 2,
    "habitat": "Fishing Village Square East Pier of Fishing Village",
    "locationIds": [
      "fishing_village",
      "fishing-village-square"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "eurasian-wigeon-obtain",
    "itemId": "eurasian-wigeon",
    "method": "BIRDWATCHING",
    "requiredLevel": 2,
    "habitat": "River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "eurasian-wren-obtain",
    "itemId": "eurasian-wren",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Spirit-Oak Pine Forest Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "european-bee-eater-obtain",
    "itemId": "european-bee-eater",
    "method": "BIRDWATCHING",
    "requiredLevel": 5,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "european-robin-obtain",
    "itemId": "european-robin",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Central Square",
    "locationIds": [
      "central-square"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "european-shag-obtain",
    "itemId": "european-shag",
    "method": "BIRDWATCHING",
    "requiredLevel": 3,
    "habitat": "Forest Island",
    "locationIds": [
      "forest-island"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "great-green-macaw-obtain",
    "itemId": "great-green-macaw",
    "method": "BIRDWATCHING",
    "requiredLevel": 5,
    "habitat": "Nest of Hundreds",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "nest-of-hundreds",
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "great-tit-obtain",
    "itemId": "great-tit",
    "method": "BIRDWATCHING",
    "requiredLevel": 2,
    "habitat": "Crater Lake Ruins",
    "locationIds": [
      "crater-lake",
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "greater-flamingo-obtain",
    "itemId": "greater-flamingo",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "hawfinch-obtain",
    "itemId": "hawfinch",
    "method": "BIRDWATCHING",
    "requiredLevel": 6,
    "habitat": "Crater Lake",
    "locationIds": [
      "crater-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "imperial-shag-obtain",
    "itemId": "imperial-shag",
    "method": "BIRDWATCHING",
    "requiredLevel": 9,
    "habitat": "East Sea Zephyr Sea",
    "locationIds": [
      "east-sea",
      "zephyr-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "jambu-fruit-dove-obtain",
    "itemId": "jambu-fruit-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 7,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "king-eider-obtain",
    "itemId": "king-eider",
    "method": "BIRDWATCHING",
    "requiredLevel": 3,
    "habitat": "River",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "lady-amherst-pheasant-obtain",
    "itemId": "lady-amherst-pheasant",
    "method": "BIRDWATCHING",
    "requiredLevel": 4,
    "habitat": "Ruins",
    "locationIds": [
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "lears-macaw-obtain",
    "itemId": "lears-macaw",
    "method": "BIRDWATCHING",
    "requiredLevel": 7,
    "habitat": "Nest of Hundreds",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "nest-of-hundreds",
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "lesser-flamingo-obtain",
    "itemId": "lesser-flamingo",
    "method": "BIRDWATCHING",
    "requiredLevel": 5,
    "habitat": "Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "long-eared-owl-obtain",
    "itemId": "long-eared-owl",
    "method": "BIRDWATCHING",
    "requiredLevel": 6,
    "habitat": "Stone Cliff",
    "locationIds": [
      "stone-cliff"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "long-tailed-tit-obtain",
    "itemId": "long-tailed-tit",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Blanc's Head",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "mallard-obtain",
    "itemId": "mallard",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "paradise-tanager-obtain",
    "itemId": "paradise-tanager",
    "method": "BIRDWATCHING",
    "requiredLevel": 9,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "peregrine-falcon-obtain",
    "itemId": "peregrine-falcon",
    "method": "BIRDWATCHING",
    "requiredLevel": 7,
    "habitat": "Stone Cliff Onsen Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake",
      "stone-cliff"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "pied-imperial-pigeon-obtain",
    "itemId": "pied-imperial-pigeon",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Fishing Village Square East Pier of Fishing Village Wharf",
    "locationIds": [
      "fishing_village",
      "fishing-village-square",
      "wharf"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "pine-grosbeak-obtain",
    "itemId": "pine-grosbeak",
    "method": "BIRDWATCHING",
    "requiredLevel": 4,
    "habitat": "Forest Island",
    "locationIds": [
      "forest-island"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "pink-necked-green-pigeon-obtain",
    "itemId": "pink-necked-green-pigeon",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "pink-pigeon-obtain",
    "itemId": "pink-pigeon",
    "method": "BIRDWATCHING",
    "requiredLevel": 7,
    "habitat": "Whale Mountain",
    "locationIds": [
      "whale-mountain"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "przevalskis-parrotbill-obtain",
    "itemId": "przevalskis-parrotbill",
    "method": "BIRDWATCHING",
    "requiredLevel": 4,
    "habitat": "Fishing Village Square",
    "locationIds": [
      "fishing_village",
      "fishing-village-square"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "red-and-green-macaw-obtain",
    "itemId": "red-and-green-macaw",
    "method": "BIRDWATCHING",
    "requiredLevel": 3,
    "habitat": "Nest of Hundreds",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "nest-of-hundreds",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "red-faced-cormorant-obtain",
    "itemId": "red-faced-cormorant",
    "method": "BIRDWATCHING",
    "requiredLevel": 6,
    "habitat": "Old Sea Whale Sea",
    "locationIds": [
      "old-sea",
      "whale-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "redpoll-obtain",
    "itemId": "redpoll",
    "method": "BIRDWATCHING",
    "requiredLevel": 8,
    "habitat": "Spirit-Oak Pine Forest",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "regent-bowerbird-obtain",
    "itemId": "regent-bowerbird",
    "method": "BIRDWATCHING",
    "requiredLevel": 4,
    "habitat": "Spirit-Oak Pine Forest",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "ruddy-shelduck-obtain",
    "itemId": "ruddy-shelduck",
    "method": "BIRDWATCHING",
    "requiredLevel": 3,
    "habitat": "Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "seagull-obtain",
    "itemId": "seagull",
    "method": "BIRDWATCHING",
    "requiredLevel": 2,
    "habitat": "Seaside",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "silver-throated-tit-obtain",
    "itemId": "silver-throated-tit",
    "method": "BIRDWATCHING",
    "requiredLevel": 3,
    "habitat": "Forest Jump Puzzle",
    "locationIds": [
      "jump-puzzle"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "smew-obtain",
    "itemId": "smew",
    "method": "BIRDWATCHING",
    "requiredLevel": 4,
    "habitat": "Forest Lake",
    "locationIds": [
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "stock-dove-obtain",
    "itemId": "stock-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 2,
    "habitat": "Central Square",
    "locationIds": [
      "central-square"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "tern-obtain",
    "itemId": "tern",
    "method": "BIRDWATCHING",
    "requiredLevel": 7,
    "habitat": "East Sea Seaside",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "verditer-flycatcher-obtain",
    "itemId": "verditer-flycatcher",
    "method": "BIRDWATCHING",
    "requiredLevel": 10,
    "habitat": "Forest Jump Puzzle",
    "locationIds": [
      "jump-puzzle"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "wallaces-fruit-dove-obtain",
    "itemId": "wallaces-fruit-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 4,
    "habitat": "Windmill Flower Field",
    "locationIds": [
      "windmill-flower-field"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "white-headed-duck-obtain",
    "itemId": "white-headed-duck",
    "method": "BIRDWATCHING",
    "requiredLevel": 9,
    "habitat": "Onsen Mountain Lake",
    "locationIds": [
      "onsen-mountain",
      "onsen-mountain-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "white-wagtail-obtain",
    "itemId": "white-wagtail",
    "method": "BIRDWATCHING",
    "requiredLevel": 4,
    "habitat": "Amethyst Beach",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "winter-eurasian-wigeon-obtain",
    "itemId": "winter-eurasian-wigeon",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Winter Birdwatching Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "winter-birdwatching-suburban-lake",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "winter-greater-flamingo-obtain",
    "itemId": "winter-greater-flamingo",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Winter Birdwatching Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "winter-birdwatching-suburban-lake",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "winter-mallard-obtain",
    "itemId": "winter-mallard",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Winter Birdwatching Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "winter-birdwatching-suburban-lake",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "winter-mandarin-duck-obtain",
    "itemId": "winter-mandarin-duck",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Winter Birdwatching",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "winter-birdwatching",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "winter-smew-obtain",
    "itemId": "winter-smew",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Winter Birdwatching Suburban Lake",
    "locationIds": [
      "suburban-lake"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "winter-birdwatching-suburban-lake",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "wonga-pigeon-obtain",
    "itemId": "wonga-pigeon",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": "Spirit-Oak Pine Forest Deer Tower Forest Lake",
    "locationIds": [
      "deer-tower",
      "forest-lake"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "woodchat-shrike-obtain",
    "itemId": "woodchat-shrike",
    "method": "BIRDWATCHING",
    "requiredLevel": 2,
    "habitat": "Suburbs",
    "locationIds": [
      "suburbs"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "yellow-bellied-flycatcher-obtain",
    "itemId": "yellow-bellied-flycatcher",
    "method": "BIRDWATCHING",
    "requiredLevel": 5,
    "habitat": "Wharf",
    "locationIds": [
      "wharf"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "avocado-obtain",
    "itemId": "avocado",
    "method": "FARMING",
    "requiredLevel": 13,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": 1440,
    "seedBuyPrice": 180,
    "seedSellPrice": null
  },
  {
    "id": "cacao-obtain",
    "itemId": "cacao",
    "method": "FARMING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": 300,
    "seedBuyPrice": 110,
    "seedSellPrice": null
  },
  {
    "id": "carrot-obtain",
    "itemId": "carrot",
    "method": "FARMING",
    "requiredLevel": 5,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [
      "spring",
      "summer",
      "fall"
    ],
    "growthTimeMinutes": 120,
    "seedBuyPrice": 50,
    "seedSellPrice": 25
  },
  {
    "id": "corn-obtain",
    "itemId": "corn",
    "method": "FARMING",
    "requiredLevel": 6,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [
      "summer",
      "fall"
    ],
    "growthTimeMinutes": 720,
    "seedBuyPrice": 170,
    "seedSellPrice": null
  },
  {
    "id": "eggplant-obtain",
    "itemId": "eggplant",
    "method": "FARMING",
    "requiredLevel": 8,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": 300,
    "seedBuyPrice": 135,
    "seedSellPrice": null
  },
  {
    "id": "grape-obtain",
    "itemId": "grape",
    "method": "FARMING",
    "requiredLevel": 7,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": 600,
    "seedBuyPrice": 160,
    "seedSellPrice": null
  },
  {
    "id": "lettuce-obtain",
    "itemId": "lettuce",
    "method": "FARMING",
    "requiredLevel": 3,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [
      "spring",
      "summer",
      "fall"
    ],
    "growthTimeMinutes": 480,
    "seedBuyPrice": 145,
    "seedSellPrice": 72
  },
  {
    "id": "paddy-obtain",
    "itemId": "paddy",
    "method": "FARMING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": 20,
    "seedBuyPrice": 12,
    "seedSellPrice": null
  },
  {
    "id": "pineapple-obtain",
    "itemId": "pineapple",
    "method": "FARMING",
    "requiredLevel": 4,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": 30,
    "seedBuyPrice": 15,
    "seedSellPrice": 7
  },
  {
    "id": "potatoes-obtain",
    "itemId": "potatoes",
    "method": "FARMING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": 60,
    "seedBuyPrice": 30,
    "seedSellPrice": 15
  },
  {
    "id": "romaine-lettuce-obtain",
    "itemId": "romaine-lettuce",
    "method": "FARMING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": 15,
    "seedBuyPrice": 10,
    "seedSellPrice": null
  },
  {
    "id": "strawberry-obtain",
    "itemId": "strawberry",
    "method": "FARMING",
    "requiredLevel": 6,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": 360,
    "seedBuyPrice": 125,
    "seedSellPrice": null
  },
  {
    "id": "tea-obtain",
    "itemId": "tea",
    "method": "FARMING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": null,
    "seedBuyPrice": 25,
    "seedSellPrice": null
  },
  {
    "id": "tomato-obtain",
    "itemId": "tomato",
    "method": "FARMING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [
      "spring",
      "summer",
      "fall"
    ],
    "growthTimeMinutes": 15,
    "seedBuyPrice": 10,
    "seedSellPrice": 5
  },
  {
    "id": "wheat-obtain",
    "itemId": "wheat",
    "method": "FARMING",
    "requiredLevel": 2,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [
      "spring",
      "summer"
    ],
    "growthTimeMinutes": 240,
    "seedBuyPrice": 95,
    "seedSellPrice": 47
  },
  {
    "id": "white-radish-obtain",
    "itemId": "white-radish",
    "method": "FARMING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seasons": [],
    "growthTimeMinutes": 15,
    "seedBuyPrice": 10,
    "seedSellPrice": null
  },
  {
    "id": "anthurium-obtain",
    "itemId": "anthurium",
    "method": "FARMING",
    "requiredLevel": 5,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 60
  },
  {
    "id": "calla-lily-obtain",
    "itemId": "calla-lily",
    "method": "FARMING",
    "requiredLevel": 6,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 300
  },
  {
    "id": "carnation-obtain",
    "itemId": "carnation",
    "method": "FARMING",
    "requiredLevel": 7,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 120
  },
  {
    "id": "corn-poppy-obtain",
    "itemId": "corn-poppy",
    "method": "FARMING",
    "requiredLevel": 5,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 60
  },
  {
    "id": "cranesbill-obtain",
    "itemId": "cranesbill",
    "method": "FARMING",
    "requiredLevel": 13,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": null
  },
  {
    "id": "daisy-obtain",
    "itemId": "daisy",
    "method": "FARMING",
    "requiredLevel": 3,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 30
  },
  {
    "id": "dandelion-obtain",
    "itemId": "dandelion",
    "method": "FARMING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": null
  },
  {
    "id": "highland-poppy-obtain",
    "itemId": "highland-poppy",
    "method": "FARMING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": null
  },
  {
    "id": "hyacinth-obtain",
    "itemId": "hyacinth",
    "method": "FARMING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 300
  },
  {
    "id": "laceleaf-obtain",
    "itemId": "laceleaf",
    "method": "FARMING",
    "requiredLevel": 5,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 60
  },
  {
    "id": "lily-obtain",
    "itemId": "lily",
    "method": "FARMING",
    "requiredLevel": 9,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 200
  },
  {
    "id": "morning-glory-obtain",
    "itemId": "morning-glory",
    "method": "FARMING",
    "requiredLevel": 6,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 90
  },
  {
    "id": "moth-orchid-obtain",
    "itemId": "moth-orchid",
    "method": "FARMING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 300
  },
  {
    "id": "pansy-obtain",
    "itemId": "pansy",
    "method": "FARMING",
    "requiredLevel": 4,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 30
  },
  {
    "id": "rose-obtain",
    "itemId": "rose",
    "method": "FARMING",
    "requiredLevel": 10,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 300
  },
  {
    "id": "tulip-obtain",
    "itemId": "tulip",
    "method": "FARMING",
    "requiredLevel": 8,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "seedBuyPrice": 150
  },
  {
    "id": "apple-obtain",
    "itemId": "apple",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Área Residencial Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bamboo-obtain",
    "itemId": "bamboo",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Forest Jump Puzzle",
    "locationIds": [
      "jump-puzzle"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-button-mushroom-blue-obtain",
    "itemId": "bizarre-button-mushroom-blue",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Windmill Flower Field Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-button-mushroom-green-obtain",
    "itemId": "bizarre-button-mushroom-green",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Windmill Flower Field Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-button-mushroom-red-obtain",
    "itemId": "bizarre-button-mushroom-red",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Windmill Flower Field Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-oyster-mushroom-orange-obtain",
    "itemId": "bizarre-oyster-mushroom-orange",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Lago del monte termal Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-oyster-mushroom-pink-obtain",
    "itemId": "bizarre-oyster-mushroom-pink",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Lago del monte termal Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-oyster-mushroom-purple-obtain",
    "itemId": "bizarre-oyster-mushroom-purple",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Lago del monte termal Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-penny-bun-pink-obtain",
    "itemId": "bizarre-penny-bun-pink",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Bosque de roble espiritual Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-penny-bun-purple-obtain",
    "itemId": "bizarre-penny-bun-purple",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Bosque de roble espiritual Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-penny-bun-red-obtain",
    "itemId": "bizarre-penny-bun-red",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Bosque de roble espiritual Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-shiitake-blue-obtain",
    "itemId": "bizarre-shiitake-blue",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Fishing Village Square Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-shiitake-black-obtain",
    "itemId": "bizarre-shiitake-black",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Fishing Village Square Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "bizarre-shiitake-red-obtain",
    "itemId": "bizarre-shiitake-red",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Fishing Village Square Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "black-truffle-obtain",
    "itemId": "black-truffle",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Forest Island Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "blueberry-obtain",
    "itemId": "blueberry",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Área Residencial Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "branch-obtain",
    "itemId": "branch",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Área Residencial Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "burdock-obtain",
    "itemId": "burdock",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Whale Mountain",
    "locationIds": [
      "whale-mountain"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "button-mushroom-obtain",
    "itemId": "button-mushroom",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Windmill Flower Field Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "fiddlehead-obtain",
    "itemId": "fiddlehead",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Deer Tower",
    "locationIds": [
      "deer-tower"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "mandarin-obtain",
    "itemId": "mandarin",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Área Residencial Gathering",
    "locationIds": [
      "residential-street"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "matsutake-obtain",
    "itemId": "matsutake",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Estanque Sombreado Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "mustard-greens-obtain",
    "itemId": "mustard-greens",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Lighthouse",
    "locationIds": [
      "lighthouse"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "oyster-mushroom-obtain",
    "itemId": "oyster-mushroom",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Lago del monte termal Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "penny-bun-obtain",
    "itemId": "penny-bun",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Bosque de roble espiritual Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "raspberry-obtain",
    "itemId": "raspberry",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Windmill Flower Field Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "shiitake-obtain",
    "itemId": "shiitake",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Fishing Village Square Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "tall-mustard-obtain",
    "itemId": "tall-mustard",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Ruins",
    "locationIds": [
      "ruins"
    ],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "weed-obtain",
    "itemId": "weed",
    "method": "FORAGING",
    "requiredLevel": null,
    "habitat": "Main Zone Área Residencial Gathering",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null
  },
  {
    "id": "apple-verbena-pie-crafting",
    "itemId": "apple-verbena-pie",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "blueberry-verbena-pie-crafting",
    "itemId": "blueberry-verbena-pie",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-black-truffle-patty-burger-crafting",
    "itemId": "brick-black-truffle-patty-burger",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-bowl-apple-shaved-ice-crafting",
    "itemId": "brick-bowl-apple-shaved-ice",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-bowl-blueberry-shaved-ice-crafting",
    "itemId": "brick-bowl-blueberry-shaved-ice",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-bowl-fruit-shaved-ice-crafting",
    "itemId": "brick-bowl-fruit-shaved-ice",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-bowl-grape-shaved-ice-crafting",
    "itemId": "brick-bowl-grape-shaved-ice",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-bowl-mandarin-shaved-ice-crafting",
    "itemId": "brick-bowl-mandarin-shaved-ice",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-bowl-pineapple-shaved-ice-crafting",
    "itemId": "brick-bowl-pineapple-shaved-ice",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-bowl-raspberry-shaved-ice-crafting",
    "itemId": "brick-bowl-raspberry-shaved-ice",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-bowl-strawberry-shaved-ice-crafting",
    "itemId": "brick-bowl-strawberry-shaved-ice",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-button-mushroom-patty-burger-crafting",
    "itemId": "brick-button-mushroom-patty-burger",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-fun-combo-set-crafting",
    "itemId": "brick-fun-combo-set",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-mushroom-patty-burger-crafting",
    "itemId": "brick-mushroom-patty-burger",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-oyster-mushroom-patty-burger-crafting",
    "itemId": "brick-oyster-mushroom-patty-burger",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-penny-bun-patty-burger-crafting",
    "itemId": "brick-penny-bun-patty-burger",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "brick-shiitake-patty-burger-crafting",
    "itemId": "brick-shiitake-patty-burger",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "colorful-egg-feast-crafting",
    "itemId": "colorful-egg-feast",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "fruit-verbena-pie-crafting",
    "itemId": "fruit-verbena-pie",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "grape-verbena-pie-crafting",
    "itemId": "grape-verbena-pie",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "grass-cake-crafting",
    "itemId": "grass-cake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "green-egg-crafting",
    "itemId": "green-egg",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "heart-puppies-con-panna-crafting",
    "itemId": "heart-puppies-con-panna",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "maltese",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "maltese-canele-crafting",
    "itemId": "maltese-canele",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "maltese",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "maltese-con-panna-crafting",
    "itemId": "maltese-con-panna",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "maltese",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "mandarin-verbena-pie-crafting",
    "itemId": "mandarin-verbena-pie",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "orange-egg-crafting",
    "itemId": "orange-egg",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "pillow-shaped-egg-yolk-and-pork-zongzi-crafting",
    "itemId": "pillow-shaped-egg-yolk-and-pork-zongzi",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "midsummer-rhyme",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "pillow-shaped-plain-rice-zongzi-crafting",
    "itemId": "pillow-shaped-plain-rice-zongzi",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "midsummer-rhyme",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "pillow-shaped-red-bean-zongzi-crafting",
    "itemId": "pillow-shaped-red-bean-zongzi",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "midsummer-rhyme",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "pineapple-verbena-pie-crafting",
    "itemId": "pineapple-verbena-pie",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "purple-egg-crafting",
    "itemId": "purple-egg",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "rainbow-heart-crafting",
    "itemId": "rainbow-heart",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "rainbow-verse",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "rainbow-spark-crafting",
    "itemId": "rainbow-spark",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "rainbow-verse",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "raspberry-verbena-pie-crafting",
    "itemId": "raspberry-verbena-pie",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "retriever-canele-crafting",
    "itemId": "retriever-canele",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "maltese",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "retriever-con-panna-crafting",
    "itemId": "retriever-con-panna",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "maltese",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "springdag-raspberry-black-tea-crafting",
    "itemId": "springdag-raspberry-black-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "springday-apple-black-tea-crafting",
    "itemId": "springday-apple-black-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "springday-blueberry-black-tea-crafting",
    "itemId": "springday-blueberry-black-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "springday-fruit-black-tea-crafting",
    "itemId": "springday-fruit-black-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "springday-grape-black-tea-crafting",
    "itemId": "springday-grape-black-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "springday-mandarin-black-tea-crafting",
    "itemId": "springday-mandarin-black-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "springday-pineapple-black-tea-crafting",
    "itemId": "springday-pineapple-black-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "springday-strawberry-black-tea-crafting",
    "itemId": "springday-strawberry-black-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "strawberry-jam-crafting",
    "itemId": "strawberry-jam",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "strawberry-verbena-pie-crafting",
    "itemId": "strawberry-verbena-pie",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "supreme-movie-meal-crafting",
    "itemId": "supreme-movie-meal",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "triangle-egg-yolk-and-pork-zongzi-crafting",
    "itemId": "triangle-egg-yolk-and-pork-zongzi",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "midsummer-rhyme",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "triangle-plain-rice-zongzi-crafting",
    "itemId": "triangle-plain-rice-zongzi",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "midsummer-rhyme",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "triangle-red-bean-zongzi-crafting",
    "itemId": "triangle-red-bean-zongzi",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "midsummer-rhyme",
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "blue-european-crayfish-sashimi-crafting",
    "itemId": "blue-european-crayfish-sashimi",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "steamed-golden-king-crab-crafting",
    "itemId": "steamed-golden-king-crab",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "steamed-king-crab-crafting",
    "itemId": "steamed-king-crab",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "apple-milkshake-crafting",
    "itemId": "apple-milkshake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "blueberry-milkshake-crafting",
    "itemId": "blueberry-milkshake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "cocoa-milk-tea-crafting",
    "itemId": "cocoa-milk-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "cocoa-milkshake-crafting",
    "itemId": "cocoa-milkshake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "grape-milkshake-crafting",
    "itemId": "grape-milkshake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "mandarin-milkshake-crafting",
    "itemId": "mandarin-milkshake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "matcha-milkshake-crafting",
    "itemId": "matcha-milkshake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "mellow-black-tea-crafting",
    "itemId": "mellow-black-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "mellow-milk-tea-crafting",
    "itemId": "mellow-milk-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "milkshake-crafting",
    "itemId": "milkshake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "pineapple-milkshake-crafting",
    "itemId": "pineapple-milkshake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "raspberry-milkshake-crafting",
    "itemId": "raspberry-milkshake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "strawberry-milkshake-crafting",
    "itemId": "strawberry-milkshake",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "daisy-tea-crafting",
    "itemId": "daisy-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "exquisite-afternoon-tea-crafting",
    "itemId": "exquisite-afternoon-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "green-milk-tea-crafting",
    "itemId": "green-milk-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "green-tea-crafting",
    "itemId": "green-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "matcha-green-milk-tea-crafting",
    "itemId": "matcha-green-milk-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "rose-tea-crafting",
    "itemId": "rose-tea",
    "method": "CRAFTING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": [],
    "seasons": [],
    "shadowSize": null,
    "notes": "Cooking recipe entry required."
  },
  {
    "id": "blue-brick-sparrow-birdwatching",
    "itemId": "blue-brick-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Onsen"
    ],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "purple-brick-sparrow-birdwatching",
    "itemId": "purple-brick-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Ruins"
    ],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "colorful-brick-sparrow-birdwatching",
    "itemId": "colorful-brick-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Block Bird Special Event"
    ],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "pink-brick-sparrow-birdwatching",
    "itemId": "pink-brick-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Stone Cliff"
    ],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "green-brick-sparrow-birdwatching",
    "itemId": "green-brick-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Crater Lake"
    ],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "blue-suit-dove-birdwatching",
    "itemId": "blue-suit-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Spirit-Oak Pine Forest",
      "[EVENT] Actor Dove"
    ],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "gray-suit-dove-birdwatching",
    "itemId": "gray-suit-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Deer Tower",
      "[EVENT] Actor Dove"
    ],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "striped-suit-dove-birdwatching",
    "itemId": "striped-suit-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "[EVENT] Actor Dove"
    ],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "red-suit-dove-birdwatching",
    "itemId": "red-suit-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Forest Island",
      "[EVENT] Actor Dove"
    ],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "green-suit-dove-birdwatching",
    "itemId": "green-suit-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Forest Jump Puzzle",
      "[EVENT] Actor Dove"
    ],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "green-peafowl-birdwatching",
    "itemId": "green-peafowl",
    "method": "BIRDWATCHING",
    "requiredLevel": 9,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "[EVENT] Nest of Hundreds"
    ],
    "isEventOnly": true,
    "eventKey": "nest-of-hundreds",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "white-peafowl-birdwatching",
    "itemId": "white-peafowl",
    "method": "BIRDWATCHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "[EVENT] Nest of Hundreds"
    ],
    "isEventOnly": true,
    "eventKey": "nest-of-hundreds",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "black-peafowl-birdwatching",
    "itemId": "black-peafowl",
    "method": "BIRDWATCHING",
    "requiredLevel": 13,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "[EVENT] Nest of Hundreds"
    ],
    "isEventOnly": true,
    "eventKey": "nest-of-hundreds",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "baikal-teal-birdwatching",
    "itemId": "baikal-teal",
    "method": "BIRDWATCHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Onsen Mountain Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "inca-tern-birdwatching",
    "itemId": "inca-tern",
    "method": "BIRDWATCHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Old Sea"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "chestnut-cheeked-starling-birdwatching",
    "itemId": "chestnut-cheeked-starling",
    "method": "BIRDWATCHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Windmill Flower Field"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "blue-headed-quail-dove-birdwatching",
    "itemId": "blue-headed-quail-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Suburbs"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "snowy-owl-birdwatching",
    "itemId": "snowy-owl",
    "method": "BIRDWATCHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Spirit-Oak Pine Forest"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "red-browed-finch-birdwatching",
    "itemId": "red-browed-finch",
    "method": "BIRDWATCHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Crater Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "atlantic-puffin-birdwatching",
    "itemId": "atlantic-puffin",
    "method": "BIRDWATCHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Whale Sea"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "blue-footed-booby-birdwatching",
    "itemId": "blue-footed-booby",
    "method": "BIRDWATCHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Zephyr Sea"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "whooper-swan-birdwatching",
    "itemId": "whooper-swan",
    "method": "BIRDWATCHING",
    "requiredLevel": 13,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Suburban Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "black-swan-birdwatching",
    "itemId": "black-swan",
    "method": "BIRDWATCHING",
    "requiredLevel": 13,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Suburban Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "black-stork-birdwatching",
    "itemId": "black-stork",
    "method": "BIRDWATCHING",
    "requiredLevel": 14,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Meadow Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "spectacled-owl-birdwatching",
    "itemId": "spectacled-owl",
    "method": "BIRDWATCHING",
    "requiredLevel": 14,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Forest Jump Puzzle"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "director-common-octopus-with-patterned-hat-fishing",
    "itemId": "director-common-octopus-with-patterned-hat",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "[EVENT] Octo Entertainment"
    ],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "LARGE",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      3829,
      2843,
      1939,
      1163,
      226
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "asian-arowana-fishing",
    "itemId": "asian-arowana",
    "method": "FISHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Meadow Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "SMALL",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "blackspot-sergeant-fishing",
    "itemId": "blackspot-sergeant",
    "method": "FISHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Zephyr Sea"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": "MEDIUM",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "lionhead-fishing",
    "itemId": "lionhead",
    "method": "FISHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Onsen Mountain Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "SMALL",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      500,
      1000
    ]
  },
  {
    "id": "whale-shark-fishing",
    "itemId": "whale-shark",
    "method": "FISHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "[EVENT] Sea Fishing"
    ],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "SUNNY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "GOLDEN",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "mahi-mahi-fishing",
    "itemId": "mahi-mahi",
    "method": "FISHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Old Sea"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY"
    ],
    "seasons": [],
    "shadowSize": "LARGE",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "moon-jelly-fishing",
    "itemId": "moon-jelly",
    "method": "FISHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "[EVENT] Sea Fishing"
    ],
    "isEventOnly": true,
    "eventKey": "sea-fishing",
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "GOLDEN",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "angelfish-fishing",
    "itemId": "angelfish",
    "method": "FISHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Suburban Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "MEDIUM",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "pink-betta-fishing",
    "itemId": "pink-betta",
    "method": "FISHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Forest Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": "SMALL",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      500,
      1000
    ]
  },
  {
    "id": "green-sea-turtle-fishing",
    "itemId": "green-sea-turtle",
    "method": "FISHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Whale Sea"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": "LARGE",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "white-faced-surgeonfish-fishing",
    "itemId": "white-faced-surgeonfish",
    "method": "FISHING",
    "requiredLevel": 13,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Old Sea"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "MEDIUM",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      50000,
      200000
    ]
  },
  {
    "id": "lionfish-fishing",
    "itemId": "lionfish",
    "method": "FISHING",
    "requiredLevel": 13,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Whale Sea"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "MEDIUM",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "blue-and-yellow-wrasse-fishing",
    "itemId": "blue-and-yellow-wrasse",
    "method": "FISHING",
    "requiredLevel": 14,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "East Sea"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": "MEDIUM",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "azure-demoiselle-fishing",
    "itemId": "azure-demoiselle",
    "method": "FISHING",
    "requiredLevel": 14,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Zephyr Sea"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": "SMALL",
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      50,
      150
    ]
  },
  {
    "id": "golden-script-supervisor-bumblebee-bug-catching",
    "itemId": "golden-script-supervisor-bumblebee",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "[EVENT] Script Supervisor Bee"
    ],
    "isEventOnly": true,
    "eventKey": "dreamlight-cinematics",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4930,
      2800,
      1500,
      450,
      320
    ]
  },
  {
    "id": "yellow-brick-large-red-damselfly-bug-catching",
    "itemId": "yellow-brick-large-red-damselfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Spirit-Oak Pine Forest"
    ],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "blue-brick-large-red-damselfly-bug-catching",
    "itemId": "blue-brick-large-red-damselfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Deer Tower"
    ],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "purple-brick-large-red-damselfly-bug-catching",
    "itemId": "purple-brick-large-red-damselfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Forest Island"
    ],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "colorful-brick-large-red-damselfly-bug-catching",
    "itemId": "colorful-brick-large-red-damselfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Special Brick Insect Event"
    ],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4930,
      2800,
      1500,
      450,
      320
    ]
  },
  {
    "id": "pink-brick-large-red-damselfly-bug-catching",
    "itemId": "pink-brick-large-red-damselfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 1,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Forest Jump Puzzle"
    ],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "atlas-beetle-bug-catching",
    "itemId": "atlas-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Spirit-Oak Pine Forest"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "orchid-mantis-bug-catching",
    "itemId": "orchid-mantis",
    "method": "BUG_CATCHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Ruins"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "queen-alexandra-s-birdwing-bug-catching",
    "itemId": "queen-alexandra-s-birdwing",
    "method": "BUG_CATCHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Suburban Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "greater-asian-lady-beetle-bug-catching",
    "itemId": "greater-asian-lady-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 11,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Whale Mountain"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "goliath-beetle-bug-catching",
    "itemId": "goliath-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Deer Tower"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "red-milkweed-locust-bug-catching",
    "itemId": "red-milkweed-locust",
    "method": "BUG_CATCHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Onsen Mountain Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "flamer-skimmer-bug-catching",
    "itemId": "flamer-skimmer",
    "method": "BUG_CATCHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Meadow Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
  },
  {
    "id": "purple-spotted-swallowtail-bug-catching",
    "itemId": "purple-spotted-swallowtail",
    "method": "BUG_CATCHING",
    "requiredLevel": 12,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Windmill Flower Field"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "scarce-morpho-bug-catching",
    "itemId": "scarce-morpho",
    "method": "BUG_CATCHING",
    "requiredLevel": 13,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Crater Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "green-metalwing-bug-catching",
    "itemId": "green-metalwing",
    "method": "BUG_CATCHING",
    "requiredLevel": 13,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Suburban Lake"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "green-snail-bug-catching",
    "itemId": "green-snail",
    "method": "BUG_CATCHING",
    "requiredLevel": 14,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Forest Island"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "glasswing-butterfly-bug-catching",
    "itemId": "glasswing-butterfly",
    "method": "BUG_CATCHING",
    "requiredLevel": 14,
    "habitat": null,
    "locationIds": [],
    "areaIds": [
      "Whale Mountain"
    ],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK"
    ],
    "seasons": [],
    "shadowSize": null,
    "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "blue-brick-clownfish-fishing",
    "itemId": "blue-brick-clownfish",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "SMALL",
    "notes": "Confirmed on Heartodex fish list as Modular Streets LV.1 Brick Clownfish variant.",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "colorful-brick-clownfish-fishing",
    "itemId": "colorful-brick-clownfish",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "Special Brick Fish Event",
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "SMALL",
    "notes": "Confirmed on Heartodex fish list as Modular Streets LV.1 Brick Clownfish variant."
  },
  {
    "id": "purple-brick-clownfish-fishing",
    "itemId": "purple-brick-clownfish",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "SMALL",
    "notes": "Confirmed on Heartodex fish list as Modular Streets LV.1 Brick Clownfish variant.",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "red-brick-clownfish-fishing",
    "itemId": "red-brick-clownfish",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "SMALL",
    "notes": "Confirmed on Heartodex fish list as Modular Streets LV.1 Brick Clownfish variant.",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "green-brick-clownfish-fishing",
    "itemId": "green-brick-clownfish",
    "method": "FISHING",
    "requiredLevel": 1,
    "habitat": "East Sea",
    "locationIds": [
      "east-sea"
    ],
    "areaIds": [],
    "isEventOnly": true,
    "eventKey": "modular-streets",
    "weather": [
      "RAINBOW",
      "SUNNY",
      "RAINY"
    ],
    "timeOfDay": [
      "DAY",
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "seasons": [],
    "shadowSize": "SMALL",
    "notes": "Confirmed on Heartodex fish list as Modular Streets LV.1 Brick Clownfish variant.",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "agrias-butterfly-obtain",
    "itemId": "agrias-butterfly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "apple-hermit-crab-obtain",
    "itemId": "apple-hermit-crab",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3688,
      2843,
      1939,
      1163,
      367
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "audouin-s-gull-obtain",
    "itemId": "audouin-s-gull",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "balloon-morpho-obtain",
    "itemId": "balloon-morpho",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4973,
      2800,
      1500,
      450,
      277
    ]
  },
  {
    "id": "balloon-nymphalidae-obtain",
    "itemId": "balloon-nymphalidae",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4973,
      2800,
      1500,
      450,
      277
    ]
  },
  {
    "id": "balloon-swallowtail-obtain",
    "itemId": "balloon-swallowtail",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4973,
      2800,
      1500,
      450,
      277
    ]
  },
  {
    "id": "bandage-fish-obtain",
    "itemId": "bandage-fish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      3743,
      2647,
      1805,
      1083,
      722
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "black-turkey-obtain",
    "itemId": "black-turkey",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "blue-camping-sparrow-obtain",
    "itemId": "blue-camping-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "blue-clockwork-sparrow-obtain",
    "itemId": "blue-clockwork-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "blue-dung-beetle-obtain",
    "itemId": "blue-dung-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "blue-floating-dust-bug-obtain",
    "itemId": "blue-floating-dust-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4983,
      2800,
      1500,
      450,
      267
    ]
  },
  {
    "id": "blue-hat-stock-dove-obtain",
    "itemId": "blue-hat-stock-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "blue-jello-fish-obtain",
    "itemId": "blue-jello-fish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3350,
      2843,
      1939,
      1163,
      705
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "blue-light-firefly-obtain",
    "itemId": "blue-light-firefly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5028,
      2800,
      1500,
      450,
      222
    ]
  },
  {
    "id": "blue-milkweed-beetle-obtain",
    "itemId": "blue-milkweed-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "blue-red-betta-obtain",
    "itemId": "blue-red-betta",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      2651,
      2669,
      2080,
      1560,
      1040
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "blue-starry-stock-dove-obtain",
    "itemId": "blue-starry-stock-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "blue-starry-swan-obtain",
    "itemId": "blue-starry-swan",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "blueberry-hermit-crab-obtain",
    "itemId": "blueberry-hermit-crab",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3688,
      2843,
      1939,
      1163,
      367
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "bourbon-red-turkey-obtain",
    "itemId": "bourbon-red-turkey",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "brown-camping-sparrow-obtain",
    "itemId": "brown-camping-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "brown-clockwork-sparrow-obtain",
    "itemId": "brown-clockwork-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "brown-hat-stock-dove-obtain",
    "itemId": "brown-hat-stock-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "brown-sauna-hat-sea-turtle-obtain",
    "itemId": "brown-sauna-hat-sea-turtle",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      1788,
      3675,
      2505,
      1503,
      529
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "candy-corn-fish-obtain",
    "itemId": "candy-corn-fish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4652,
      2262,
      1543,
      926,
      617
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "clockwork-frog-obtain",
    "itemId": "clockwork-frog",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      2519,
      3198,
      2181,
      1309,
      793
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "coal-bug-obtain",
    "itemId": "coal-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "crawling-firecracker-bug-obtain",
    "itemId": "crawling-firecracker-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5084,
      2800,
      1500,
      450,
      166
    ]
  },
  {
    "id": "dragonfruit-hermit-crab-obtain",
    "itemId": "dragonfruit-hermit-crab",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3688,
      2843,
      1939,
      1163,
      367
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "eastern-lubber-grasshopper-obtain",
    "itemId": "eastern-lubber-grasshopper",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": []
  },
  {
    "id": "firefly-squid-obtain",
    "itemId": "firefly-squid",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4192,
      2622,
      1788,
      1073,
      325
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "flame-skimmer-obtain",
    "itemId": "flame-skimmer",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY"
    ],
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ]
  },
  {
    "id": "flatback-turtle-obtain",
    "itemId": "flatback-turtle",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4192,
      2622,
      1788,
      1073,
      325
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "flying-firecracker-bug-obtain",
    "itemId": "flying-firecracker-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5084,
      2800,
      1500,
      450,
      166
    ]
  },
  {
    "id": "ghost-frog-obtain",
    "itemId": "ghost-frog",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      3743,
      2647,
      1805,
      1083,
      722
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "gin-matsuba-koi-obtain",
    "itemId": "gin-matsuba-koi",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      2477,
      3183,
      2170,
      1302,
      868
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "gold-bug-obtain",
    "itemId": "gold-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4930,
      2800,
      1500,
      450,
      320
    ]
  },
  {
    "id": "golden-clockwork-ladybug-obtain",
    "itemId": "golden-clockwork-ladybug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4362,
      2800,
      1500,
      450,
      888
    ]
  },
  {
    "id": "golden-dung-beetle-obtain",
    "itemId": "golden-dung-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4930,
      2800,
      1500,
      450,
      320
    ]
  },
  {
    "id": "golden-koi-obtain",
    "itemId": "golden-koi",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      1982,
      3392,
      2313,
      1388,
      925
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "golden-pheasant-obtain",
    "itemId": "golden-pheasant",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "gray-bouncy-dust-insect-obtain",
    "itemId": "gray-bouncy-dust-insect",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      2800,
      1500,
      450,
      250
    ]
  },
  {
    "id": "gray-camping-sparrow-obtain",
    "itemId": "gray-camping-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "gray-clockwork-sparrow-obtain",
    "itemId": "gray-clockwork-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "great-black-firefly-obtain",
    "itemId": "great-black-firefly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "green-bath-towel-mako-shark-obtain",
    "itemId": "green-bath-towel-mako-shark",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "green-bouncy-dust-bug-obtain",
    "itemId": "green-bouncy-dust-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5000,
      2800,
      1500,
      450,
      250
    ]
  },
  {
    "id": "green-camping-sparrow-obtain",
    "itemId": "green-camping-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "green-dung-beetle-obtain",
    "itemId": "green-dung-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "green-flower-chafer-obtain",
    "itemId": "green-flower-chafer",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "green-hat-stock-dove-obtain",
    "itemId": "green-hat-stock-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "green-jello-fish-obtain",
    "itemId": "green-jello-fish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3350,
      2843,
      1939,
      1163,
      705
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "green-light-firefly-obtain",
    "itemId": "green-light-firefly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5028,
      2800,
      1500,
      450,
      222
    ]
  },
  {
    "id": "green-light-sea-star-obtain",
    "itemId": "green-light-sea-star",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      3762,
      2843,
      1939,
      1163,
      293
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "green-starry-stock-dove-obtain",
    "itemId": "green-starry-stock-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "green-starry-swan-obtain",
    "itemId": "green-starry-swan",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "grey-mantled-albatross-obtain",
    "itemId": "grey-mantled-albatross",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "hanging-firecracker-bug-obtain",
    "itemId": "hanging-firecracker-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5028,
      2800,
      1500,
      450,
      222
    ]
  },
  {
    "id": "ice-bug-obtain",
    "itemId": "ice-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "indigo-hanging-dust-bug-obtain",
    "itemId": "indigo-hanging-dust-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4869,
      2800,
      1500,
      450,
      381
    ]
  },
  {
    "id": "indigo-jello-fish-obtain",
    "itemId": "indigo-jello-fish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3350,
      2843,
      1939,
      1163,
      705
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "inflatable-mallard-obtain",
    "itemId": "inflatable-mallard",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "inflatable-ruddy-shelduck-obtain",
    "itemId": "inflatable-ruddy-shelduck",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "inflatable-smew-obtain",
    "itemId": "inflatable-smew",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "inflatable-wigeon-obtain",
    "itemId": "inflatable-wigeon",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "jumping-firecracker-bug-obtain",
    "itemId": "jumping-firecracker-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4695,
      2800,
      1500,
      450,
      555
    ]
  },
  {
    "id": "kissing-fish-obtain",
    "itemId": "kissing-fish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      2651,
      2669,
      2080,
      1560,
      1040
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "koi-obtain",
    "itemId": "koi",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      2477,
      3183,
      2170,
      1302,
      868
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "lady-amherst-s-pheasant-obtain",
    "itemId": "lady-amherst-s-pheasant",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "little-egret-obtain",
    "itemId": "little-egret",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "lychee-shieldbug-obtain",
    "itemId": "lychee-shieldbug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [],
    "timeOfDay": []
  },
  {
    "id": "mandarin-duck-obtain",
    "itemId": "mandarin-duck",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "mandarin-fish-obtain",
    "itemId": "mandarin-fish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4192,
      2622,
      1788,
      1073,
      325
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "mandarin-hermit-crab-obtain",
    "itemId": "mandarin-hermit-crab",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3688,
      2843,
      1939,
      1163,
      367
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "morpho-luna-obtain",
    "itemId": "morpho-luna",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4930,
      2800,
      1500,
      450,
      320
    ]
  },
  {
    "id": "ocellated-turkey-obtain",
    "itemId": "ocellated-turkey",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "olive-ridley-turtle-obtain",
    "itemId": "olive-ridley-turtle",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4192,
      2622,
      1788,
      1073,
      325
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "orange-camping-sparrow-obtain",
    "itemId": "orange-camping-sparrow",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "orange-jello-fish-obtain",
    "itemId": "orange-jello-fish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3350,
      2843,
      1939,
      1163,
      705
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "oriental-magpie-obtain",
    "itemId": "oriental-magpie",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "permit-obtain",
    "itemId": "permit",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4500,
      2000,
      1500,
      1200,
      800
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "pied-falconet-obtain",
    "itemId": "pied-falconet",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "pied-kingfisher-obtain",
    "itemId": "pied-kingfisher",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "pink-atlantic-salmon-obtain",
    "itemId": "pink-atlantic-salmon",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "pink-hanging-dust-bug-obtain",
    "itemId": "pink-hanging-dust-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4869,
      2800,
      1500,
      450,
      381
    ]
  },
  {
    "id": "pink-hat-stock-dove-obtain",
    "itemId": "pink-hat-stock-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "pink-king-crab-obtain",
    "itemId": "pink-king-crab",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "pink-light-firefly-obtain",
    "itemId": "pink-light-firefly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5028,
      2800,
      1500,
      450,
      222
    ]
  },
  {
    "id": "pink-necked-firefly-obtain",
    "itemId": "pink-necked-firefly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "pink-seahorse-obtain",
    "itemId": "pink-seahorse",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      150,
      300
    ]
  },
  {
    "id": "pink-shortfin-mako-shark-obtain",
    "itemId": "pink-shortfin-mako-shark",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "pink-swordfish-obtain",
    "itemId": "pink-swordfish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "pomarine-skua-obtain",
    "itemId": "pomarine-skua",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "psionic-indian-fritillary-obtain",
    "itemId": "psionic-indian-fritillary",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5084,
      2800,
      1500,
      450,
      166
    ]
  },
  {
    "id": "psionic-luna-moth-obtain",
    "itemId": "psionic-luna-moth",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5084,
      2800,
      1500,
      450,
      166
    ]
  },
  {
    "id": "psionic-queen-alexandra-s-birdwing-obtain",
    "itemId": "psionic-queen-alexandra-s-birdwing",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "psionic-rimmed-window-firefly-obtain",
    "itemId": "psionic-rimmed-window-firefly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5084,
      2800,
      1500,
      450,
      166
    ]
  },
  {
    "id": "purple-dung-beetle-obtain",
    "itemId": "purple-dung-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "purple-floating-dust-bug-obtain",
    "itemId": "purple-floating-dust-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4983,
      2800,
      1500,
      450,
      267
    ]
  },
  {
    "id": "purple-jello-fish-obtain",
    "itemId": "purple-jello-fish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3350,
      2843,
      1939,
      1163,
      705
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "purple-light-firefly-obtain",
    "itemId": "purple-light-firefly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5028,
      2800,
      1500,
      450,
      222
    ]
  },
  {
    "id": "purple-light-sea-star-obtain",
    "itemId": "purple-light-sea-star",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      3725,
      2843,
      1939,
      1163,
      330
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "purple-starry-stock-dove-obtain",
    "itemId": "purple-starry-stock-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "purple-starry-swan-obtain",
    "itemId": "purple-starry-swan",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "rajah-brooke-s-birdwing-obtain",
    "itemId": "rajah-brooke-s-birdwing",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "raspberry-hermit-crab-obtain",
    "itemId": "raspberry-hermit-crab",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3688,
      2843,
      1939,
      1163,
      367
    ],
    "weightRange": [
      1000,
      3000
    ]
  },
  {
    "id": "red-clockwork-ladybug-obtain",
    "itemId": "red-clockwork-ladybug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5028,
      2800,
      1500,
      450,
      222
    ]
  },
  {
    "id": "red-crowned-crane-obtain",
    "itemId": "red-crowned-crane",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "red-dung-beetle-obtain",
    "itemId": "red-dung-beetle",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "red-jello-fish-obtain",
    "itemId": "red-jello-fish",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      3350,
      2843,
      1939,
      1163,
      705
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "red-koi-obtain",
    "itemId": "red-koi",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      2477,
      3183,
      2170,
      1302,
      868
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "rimmed-window-firefly-obtain",
    "itemId": "rimmed-window-firefly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "rock-bug-obtain",
    "itemId": "rock-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "roseate-spoonbill-obtain",
    "itemId": "roseate-spoonbill",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "royal-palm-turkey-obtain",
    "itemId": "royal-palm-turkey",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "sea-slug-obtain",
    "itemId": "sea-slug",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "SMALL",
    "starWeights": [
      5284,
      2129,
      1452,
      871,
      264
    ],
    "weightRange": [
      20,
      70
    ]
  },
  {
    "id": "snow-bug-obtain",
    "itemId": "snow-bug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "snowy-window-firefly-obtain",
    "itemId": "snowy-window-firefly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4950,
      2800,
      1500,
      450,
      300
    ]
  },
  {
    "id": "spectral-octopus-obtain",
    "itemId": "spectral-octopus",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      3309,
      2831,
      1930,
      1158,
      772
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "striped-bath-towel-mako-shark-obtain",
    "itemId": "striped-bath-towel-mako-shark",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      3526,
      2843,
      1939,
      1163,
      529
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "striped-sauna-hat-sea-turtle-obtain",
    "itemId": "striped-sauna-hat-sea-turtle",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "sulkowsky-s-morpho-obtain",
    "itemId": "sulkowsky-s-morpho",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4750,
      2600,
      1500,
      750,
      400
    ]
  },
  {
    "id": "turkey-obtain",
    "itemId": "turkey",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "wandering-albatross-obtain",
    "itemId": "wandering-albatross",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "white-banded-erebus-moth-obtain",
    "itemId": "white-banded-erebus-moth",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      5019,
      2800,
      1500,
      450,
      231
    ]
  },
  {
    "id": "white-clockwork-ladybug-obtain",
    "itemId": "white-clockwork-ladybug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4991,
      2800,
      1500,
      450,
      259
    ]
  },
  {
    "id": "white-faced-storm-petrel-obtain",
    "itemId": "white-faced-storm-petrel",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "white-hat-stock-dove-obtain",
    "itemId": "white-hat-stock-dove",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "white-sauna-hat-sea-turtle-obtain",
    "itemId": "white-sauna-hat-sea-turtle",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "MEDIUM",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      2000,
      5000
    ]
  },
  {
    "id": "white-spoonbill-obtain",
    "itemId": "white-spoonbill",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "white-winged-tern-obtain",
    "itemId": "white-winged-tern",
    "method": "BIRDWATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ]
  },
  {
    "id": "yellow-bath-towel-mako-shark-obtain",
    "itemId": "yellow-bath-towel-mako-shark",
    "method": "FISHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "shadowSize": "LARGE",
    "starWeights": [
      3844,
      2843,
      1939,
      1163,
      211
    ],
    "weightRange": [
      80000,
      150000
    ]
  },
  {
    "id": "yellow-clockwork-ladybug-obtain",
    "itemId": "yellow-clockwork-ladybug",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4991,
      2800,
      1500,
      450,
      259
    ]
  },
  {
    "id": "yellow-light-firefly-obtain",
    "itemId": "yellow-light-firefly",
    "method": "BUG_CATCHING",
    "requiredLevel": null,
    "habitat": null,
    "locationIds": [],
    "areaIds": [],
    "isEventOnly": false,
    "eventKey": null,
    "weather": [
      "SUNNY",
      "RAINY",
      "RAINBOW"
    ],
    "timeOfDay": [
      "DAWN",
      "DAY",
      "DUSK",
      "NIGHT"
    ],
    "starWeights": [
      4695,
      2800,
      1500,
      450,
      555
    ]
  }
];

export const OBTAIN_METHODS_BY_ITEM_ID: Record<string, ObtainMethod[]> = {
  "anglerfish": [
    {
      "id": "anglerfish-obtain",
      "itemId": "anglerfish",
      "method": "FISHING",
      "requiredLevel": 2,
      "habitat": "Sea Fishing",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "GOLDEN",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "arctic-char": [
    {
      "id": "arctic-char-obtain",
      "itemId": "arctic-char",
      "method": "FISHING",
      "requiredLevel": 10,
      "habitat": "Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "atlantic-mackerel": [
    {
      "id": "atlantic-mackerel-obtain",
      "itemId": "atlantic-mackerel",
      "method": "FISHING",
      "requiredLevel": 5,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "atlantic-pygmy-octopus": [
    {
      "id": "atlantic-pygmy-octopus-obtain",
      "itemId": "atlantic-pygmy-octopus",
      "method": "FISHING",
      "requiredLevel": 2,
      "habitat": "Zephyr Sea",
      "locationIds": [
        "zephyr-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "atlantic-salmon": [
    {
      "id": "atlantic-salmon-obtain",
      "itemId": "atlantic-salmon",
      "method": "FISHING",
      "requiredLevel": 3,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "barbel": [
    {
      "id": "barbel-obtain",
      "itemId": "barbel",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Shallow River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "beltfish": [
    {
      "id": "beltfish-obtain",
      "itemId": "beltfish",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Zephyr Sea",
      "locationIds": [
        "zephyr-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "blackspot-seabream": [
    {
      "id": "blackspot-seabream-obtain",
      "itemId": "blackspot-seabream",
      "method": "FISHING",
      "requiredLevel": 7,
      "habitat": "Zephyr Sea",
      "locationIds": [
        "zephyr-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "blue-european-crayfish": [
    {
      "id": "blue-european-crayfish-obtain",
      "itemId": "blue-european-crayfish",
      "method": "FISHING",
      "requiredLevel": 8,
      "habitat": "Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "bluefin-tuna": [
    {
      "id": "bluefin-tuna-obtain",
      "itemId": "bluefin-tuna",
      "method": "FISHING",
      "requiredLevel": 9,
      "habitat": "Zephyr Sea",
      "locationIds": [
        "zephyr-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        100000,
        200000
      ]
    }
  ],
  "bluegill": [
    {
      "id": "bluegill-obtain",
      "itemId": "bluegill",
      "method": "FISHING",
      "requiredLevel": 10,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "burbot": [
    {
      "id": "burbot-obtain",
      "itemId": "burbot",
      "method": "FISHING",
      "requiredLevel": 4,
      "habitat": "Tranquil River",
      "locationIds": [
        "tranquil-river"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        2000,
        20000
      ]
    }
  ],
  "butterfly-koi": [
    {
      "id": "butterfly-koi-obtain",
      "itemId": "butterfly-koi",
      "method": "FISHING",
      "requiredLevel": 4,
      "habitat": "Meadow Lake",
      "locationIds": [
        "meadow-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "chum-salmon": [
    {
      "id": "chum-salmon-obtain",
      "itemId": "chum-salmon",
      "method": "FISHING",
      "requiredLevel": 6,
      "habitat": "Tranquil River",
      "locationIds": [
        "tranquil-river"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "clownfish": [
    {
      "id": "clownfish-obtain",
      "itemId": "clownfish",
      "method": "FISHING",
      "requiredLevel": 3,
      "habitat": "Old Sea",
      "locationIds": [
        "old-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "common-barbel": [
    {
      "id": "common-barbel-obtain",
      "itemId": "common-barbel",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Shallow River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "NIGHT",
        "DAWN",
        "DAY",
        "DUSK"
      ],
      "shadowSize": null
    }
  ],
  "common-bleak": [
    {
      "id": "common-bleak-obtain",
      "itemId": "common-bleak",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Lake",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "common-carp": [
    {
      "id": "common-carp-obtain",
      "itemId": "common-carp",
      "method": "FISHING",
      "requiredLevel": 4,
      "habitat": "Rosy River",
      "locationIds": [
        "rosy-river"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "common-chub": [
    {
      "id": "common-chub-obtain",
      "itemId": "common-chub",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Lake",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "common-octopus": [
    {
      "id": "common-octopus-obtain",
      "itemId": "common-octopus",
      "method": "FISHING",
      "requiredLevel": 2,
      "habitat": "Sea Fishing",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "common-prawn": [
    {
      "id": "common-prawn-obtain",
      "itemId": "common-prawn",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "common-rudd": [
    {
      "id": "common-rudd-obtain",
      "itemId": "common-rudd",
      "method": "FISHING",
      "requiredLevel": 5,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "common-shrimp": [
    {
      "id": "common-shrimp-obtain",
      "itemId": "common-shrimp",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "NIGHT",
        "DAWN",
        "DAY",
        "DUSK"
      ],
      "shadowSize": null
    }
  ],
  "common-whitefish": [
    {
      "id": "common-whitefish-obtain",
      "itemId": "common-whitefish",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "crucian-carp": [
    {
      "id": "crucian-carp-obtain",
      "itemId": "crucian-carp",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "director-common-octopus-w-cinnamon-hat": [
    {
      "id": "director-common-octopus-w-cinnamon-hat-obtain",
      "itemId": "director-common-octopus-w-cinnamon-hat",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        3829,
        2843,
        1939,
        1163,
        226
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "director-pygmy-octopus-w-brown-hat": [
    {
      "id": "director-pygmy-octopus-w-brown-hat-obtain",
      "itemId": "director-pygmy-octopus-w-brown-hat",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3829,
        2843,
        1939,
        1163,
        226
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "director-pygmy-octopus-w-cyan-hat": [
    {
      "id": "director-pygmy-octopus-w-cyan-hat-obtain",
      "itemId": "director-pygmy-octopus-w-cyan-hat",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3791,
        2843,
        1939,
        1163,
        264
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "director-pygmy-octopus-w-navy-hat": [
    {
      "id": "director-pygmy-octopus-w-navy-hat-obtain",
      "itemId": "director-pygmy-octopus-w-navy-hat",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3829,
        2843,
        1939,
        1163,
        226
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "edible-frog": [
    {
      "id": "edible-frog-obtain",
      "itemId": "edible-frog",
      "method": "FISHING",
      "requiredLevel": 3,
      "habitat": "Lake",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "european-crayfish": [
    {
      "id": "european-crayfish-obtain",
      "itemId": "european-crayfish",
      "method": "FISHING",
      "requiredLevel": 3,
      "habitat": "Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "european-eel": [
    {
      "id": "european-eel-obtain",
      "itemId": "european-eel",
      "method": "FISHING",
      "requiredLevel": 7,
      "habitat": "Old Sea",
      "locationIds": [
        "old-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "european-flying-squid": [
    {
      "id": "european-flying-squid-obtain",
      "itemId": "european-flying-squid",
      "method": "FISHING",
      "requiredLevel": 5,
      "habitat": "Sea Fishing",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "GOLDEN",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "european-lobster": [
    {
      "id": "european-lobster-obtain",
      "itemId": "european-lobster",
      "method": "FISHING",
      "requiredLevel": 5,
      "habitat": "Zephyr Sea",
      "locationIds": [
        "zephyr-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "european-mudminnow": [
    {
      "id": "european-mudminnow-obtain",
      "itemId": "european-mudminnow",
      "method": "FISHING",
      "requiredLevel": 8,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAWN",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "european-perch": [
    {
      "id": "european-perch-obtain",
      "itemId": "european-perch",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "european-plaice": [
    {
      "id": "european-plaice-obtain",
      "itemId": "european-plaice",
      "method": "FISHING",
      "requiredLevel": 4,
      "habitat": "Old Sea",
      "locationIds": [
        "old-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "european-smelt": [
    {
      "id": "european-smelt-obtain",
      "itemId": "european-smelt",
      "method": "FISHING",
      "requiredLevel": 2,
      "habitat": "Meadow Lake",
      "locationIds": [
        "meadow-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "false-scad": [
    {
      "id": "false-scad-obtain",
      "itemId": "false-scad",
      "method": "FISHING",
      "requiredLevel": 2,
      "habitat": "Zephyr Sea",
      "locationIds": [
        "zephyr-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "freshwater-blenny": [
    {
      "id": "freshwater-blenny-obtain",
      "itemId": "freshwater-blenny",
      "method": "FISHING",
      "requiredLevel": 5,
      "habitat": "Rosy River",
      "locationIds": [
        "rosy-river"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "frostspore-king-crab": [
    {
      "id": "frostspore-king-crab-obtain",
      "itemId": "frostspore-king-crab",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Frostspore Fish",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "frostspore-fish",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "frostspore-ocean-sunfish": [
    {
      "id": "frostspore-ocean-sunfish-obtain",
      "itemId": "frostspore-ocean-sunfish",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Frostspore Fish",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "frostspore-fish",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "frostspore-puffer-fish": [
    {
      "id": "frostspore-puffer-fish-obtain",
      "itemId": "frostspore-puffer-fish",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Frostspore Fish",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "frostspore-fish",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "frostspore-seahorse": [
    {
      "id": "frostspore-seahorse-obtain",
      "itemId": "frostspore-seahorse",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Frostspore Fish",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "frostspore-fish",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "frostspore-whale-shark": [
    {
      "id": "frostspore-whale-shark-obtain",
      "itemId": "frostspore-whale-shark",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Frostspore Fish",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "frostspore-fish",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        3791,
        2843,
        1939,
        1163,
        264
      ],
      "weightRange": [
        50000,
        200000
      ]
    }
  ],
  "giant-oarfish": [
    {
      "id": "giant-oarfish-obtain",
      "itemId": "giant-oarfish",
      "method": "FISHING",
      "requiredLevel": 7,
      "habitat": "Sea Fishing",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN"
      ],
      "shadowSize": "GOLDEN",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        100000,
        200000
      ]
    }
  ],
  "goby": [
    {
      "id": "goby-obtain",
      "itemId": "goby",
      "method": "FISHING",
      "requiredLevel": 4,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        100,
        300
      ]
    }
  ],
  "golden-king-crab": [
    {
      "id": "golden-king-crab-obtain",
      "itemId": "golden-king-crab",
      "method": "FISHING",
      "requiredLevel": 8,
      "habitat": "Sea Fishing",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "GOLDEN",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        5000,
        20000
      ]
    }
  ],
  "goldfish": [
    {
      "id": "goldfish-obtain",
      "itemId": "goldfish",
      "method": "FISHING",
      "requiredLevel": 8,
      "habitat": "Meadow Lake",
      "locationIds": [
        "meadow-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "grayling": [
    {
      "id": "grayling-obtain",
      "itemId": "grayling",
      "method": "FISHING",
      "requiredLevel": 6,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "haddock": [
    {
      "id": "haddock-obtain",
      "itemId": "haddock",
      "method": "FISHING",
      "requiredLevel": 8,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "hermit-crab": [
    {
      "id": "hermit-crab-obtain",
      "itemId": "hermit-crab",
      "method": "FISHING",
      "requiredLevel": 3,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "horse-mackerel": [
    {
      "id": "horse-mackerel-obtain",
      "itemId": "horse-mackerel",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "sea",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL"
    }
  ],
  "huchen": [
    {
      "id": "huchen-obtain",
      "itemId": "huchen",
      "method": "FISHING",
      "requiredLevel": 9,
      "habitat": "Giantwood River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "king-crab": [
    {
      "id": "king-crab-obtain",
      "itemId": "king-crab",
      "method": "FISHING",
      "requiredLevel": 8,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "large-pearl-mussel": [
    {
      "id": "large-pearl-mussel-obtain",
      "itemId": "large-pearl-mussel",
      "method": "FISHING",
      "requiredLevel": 6,
      "habitat": "Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "largemouth-bass": [
    {
      "id": "largemouth-bass-obtain",
      "itemId": "largemouth-bass",
      "method": "FISHING",
      "requiredLevel": 2,
      "habitat": "Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "mediterranean-killifish": [
    {
      "id": "mediterranean-killifish-obtain",
      "itemId": "mediterranean-killifish",
      "method": "FISHING",
      "requiredLevel": 7,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "minnow": [
    {
      "id": "minnow-obtain",
      "itemId": "minnow",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Tranquil River",
      "locationIds": [
        "tranquil-river"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "moonfish": [
    {
      "id": "moonfish-obtain",
      "itemId": "moonfish",
      "method": "FISHING",
      "requiredLevel": 9,
      "habitat": "Sea Fishing",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "GOLDEN",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "mottled-sculpin": [
    {
      "id": "mottled-sculpin-obtain",
      "itemId": "mottled-sculpin",
      "method": "FISHING",
      "requiredLevel": 7,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "mud-sunfish": [
    {
      "id": "mud-sunfish-obtain",
      "itemId": "mud-sunfish",
      "method": "FISHING",
      "requiredLevel": 3,
      "habitat": "Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "mussel": [
    {
      "id": "mussel-obtain",
      "itemId": "mussel",
      "method": "FISHING",
      "requiredLevel": 4,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "northern-pike": [
    {
      "id": "northern-pike-obtain",
      "itemId": "northern-pike",
      "method": "FISHING",
      "requiredLevel": 9,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "nursehound": [
    {
      "id": "nursehound-obtain",
      "itemId": "nursehound",
      "method": "FISHING",
      "requiredLevel": 6,
      "habitat": "Sea Fishing",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "ocean-sunfish": [
    {
      "id": "ocean-sunfish-obtain",
      "itemId": "ocean-sunfish",
      "method": "FISHING",
      "requiredLevel": 9,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "oriental-shrimp": [
    {
      "id": "oriental-shrimp-obtain",
      "itemId": "oriental-shrimp",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "puffer-fish": [
    {
      "id": "puffer-fish-obtain",
      "itemId": "puffer-fish",
      "method": "FISHING",
      "requiredLevel": 6,
      "habitat": "Old Sea",
      "locationIds": [
        "old-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "pumpkinseed": [
    {
      "id": "pumpkinseed-obtain",
      "itemId": "pumpkinseed",
      "method": "FISHING",
      "requiredLevel": 9,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "rabbit-fish": [
    {
      "id": "rabbit-fish-obtain",
      "itemId": "rabbit-fish",
      "method": "FISHING",
      "requiredLevel": 4,
      "habitat": "Ocean",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "red-bellied-piranha": [
    {
      "id": "red-bellied-piranha-obtain",
      "itemId": "red-bellied-piranha",
      "method": "FISHING",
      "requiredLevel": 4,
      "habitat": "Giantwood River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "river-crab": [
    {
      "id": "river-crab-obtain",
      "itemId": "river-crab",
      "method": "FISHING",
      "requiredLevel": 4,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "ruffe": [
    {
      "id": "ruffe-obtain",
      "itemId": "ruffe",
      "method": "FISHING",
      "requiredLevel": 3,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "sardine": [
    {
      "id": "sardine-obtain",
      "itemId": "sardine",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Ocean",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "scad": [
    {
      "id": "scad-obtain",
      "itemId": "scad",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "schneider": [
    {
      "id": "schneider-obtain",
      "itemId": "schneider",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "sea-bass": [
    {
      "id": "sea-bass-obtain",
      "itemId": "sea-bass",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Ocean",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "sea-stickleback": [
    {
      "id": "sea-stickleback-obtain",
      "itemId": "sea-stickleback",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Old Sea",
      "locationIds": [
        "old-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "seahorse": [
    {
      "id": "seahorse-obtain",
      "itemId": "seahorse",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "shortfin-mako-shark": [
    {
      "id": "shortfin-mako-shark-obtain",
      "itemId": "shortfin-mako-shark",
      "method": "FISHING",
      "requiredLevel": 10,
      "habitat": "Sea Fishing",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN"
      ],
      "shadowSize": "GOLDEN",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "skipjack-tuna": [
    {
      "id": "skipjack-tuna-obtain",
      "itemId": "skipjack-tuna",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Ocean",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "smooth-hammerhead": [
    {
      "id": "smooth-hammerhead-obtain",
      "itemId": "smooth-hammerhead",
      "method": "FISHING",
      "requiredLevel": 10,
      "habitat": "Old Sea",
      "locationIds": [
        "old-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "spined-loach": [
    {
      "id": "spined-loach-obtain",
      "itemId": "spined-loach",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Giantwood River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        100,
        400
      ]
    }
  ],
  "stone-loach": [
    {
      "id": "stone-loach-obtain",
      "itemId": "stone-loach",
      "method": "FISHING",
      "requiredLevel": 2,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "streber": [
    {
      "id": "streber-obtain",
      "itemId": "streber",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Rosy River",
      "locationIds": [
        "rosy-river"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        1000,
        2000
      ]
    }
  ],
  "striped-red-mullet": [
    {
      "id": "striped-red-mullet-obtain",
      "itemId": "striped-red-mullet",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Sea Fishing",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "GOLDEN",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        5000,
        20000
      ]
    }
  ],
  "swordfish": [
    {
      "id": "swordfish-obtain",
      "itemId": "swordfish",
      "method": "FISHING",
      "requiredLevel": 10,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "tadpole": [
    {
      "id": "tadpole-obtain",
      "itemId": "tadpole",
      "method": "FISHING",
      "requiredLevel": 4,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "tench": [
    {
      "id": "tench-obtain",
      "itemId": "tench",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "three-spined-stickleback": [
    {
      "id": "three-spined-stickleback-obtain",
      "itemId": "three-spined-stickleback",
      "method": "FISHING",
      "requiredLevel": 7,
      "habitat": "Shallow River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "tilapia": [
    {
      "id": "tilapia-obtain",
      "itemId": "tilapia",
      "method": "FISHING",
      "requiredLevel": 3,
      "habitat": "River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "trout": [
    {
      "id": "trout-obtain",
      "itemId": "trout",
      "method": "FISHING",
      "requiredLevel": 5,
      "habitat": "Meadow Lake",
      "locationIds": [
        "meadow-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "tub-gurnard": [
    {
      "id": "tub-gurnard-obtain",
      "itemId": "tub-gurnard",
      "method": "FISHING",
      "requiredLevel": 6,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "turbot": [
    {
      "id": "turbot-obtain",
      "itemId": "turbot",
      "method": "FISHING",
      "requiredLevel": 2,
      "habitat": "Sea Fishing",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "wels-catfish": [
    {
      "id": "wels-catfish-obtain",
      "itemId": "wels-catfish",
      "method": "FISHING",
      "requiredLevel": 10,
      "habitat": "Meadow Lake",
      "locationIds": [
        "meadow-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        50000,
        200000
      ]
    }
  ],
  "zander": [
    {
      "id": "zander-obtain",
      "itemId": "zander",
      "method": "FISHING",
      "requiredLevel": 3,
      "habitat": "Giantwood River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "alpine-longhorn-beetle": [
    {
      "id": "alpine-longhorn-beetle-obtain",
      "itemId": "alpine-longhorn-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 5,
      "habitat": "Forest Island",
      "locationIds": [
        "forest-island"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "amethyst-flower-beetle": [
    {
      "id": "amethyst-flower-beetle-obtain",
      "itemId": "amethyst-flower-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 2,
      "habitat": "Residential Area",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "ant": [
    {
      "id": "ant-obtain",
      "itemId": "ant",
      "method": "BUG_CATCHING",
      "requiredLevel": 3,
      "habitat": "Fishing Village Square East Pier of Fishing Village",
      "locationIds": [
        "fishing_village",
        "fishing-village-square"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "apollo": [
    {
      "id": "apollo-obtain",
      "itemId": "apollo",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Bait the Insects",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "bait-the-insects",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ]
    }
  ],
  "asian-lady-beetle": [
    {
      "id": "asian-lady-beetle-obtain",
      "itemId": "asian-lady-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 5,
      "habitat": "Deer Tower",
      "locationIds": [
        "deer-tower"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "asparagus-beetle": [
    {
      "id": "asparagus-beetle-obtain",
      "itemId": "asparagus-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ]
    }
  ],
  "bagworm-moth": [
    {
      "id": "bagworm-moth-obtain",
      "itemId": "bagworm-moth",
      "method": "BUG_CATCHING",
      "requiredLevel": 10,
      "habitat": "Deer Tower",
      "locationIds": [
        "deer-tower"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "beautiful-demoiselle": [
    {
      "id": "beautiful-demoiselle-obtain",
      "itemId": "beautiful-demoiselle",
      "method": "BUG_CATCHING",
      "requiredLevel": 6,
      "habitat": "Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "beautiful-leopard": [
    {
      "id": "beautiful-leopard-obtain",
      "itemId": "beautiful-leopard",
      "method": "BUG_CATCHING",
      "requiredLevel": 4,
      "habitat": "Wharf",
      "locationIds": [
        "wharf"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "blue-morpho": [
    {
      "id": "blue-morpho-obtain",
      "itemId": "blue-morpho",
      "method": "BUG_CATCHING",
      "requiredLevel": 7,
      "habitat": "Spirit-Oak Pine Forest",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "blue-shieldbug": [
    {
      "id": "blue-shieldbug-obtain",
      "itemId": "blue-shieldbug",
      "method": "BUG_CATCHING",
      "requiredLevel": 6,
      "habitat": "Lighthouse",
      "locationIds": [
        "lighthouse"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "bumblebee": [
    {
      "id": "bumblebee-obtain",
      "itemId": "bumblebee",
      "method": "BUG_CATCHING",
      "requiredLevel": 2,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "cabbage-white": [
    {
      "id": "cabbage-white-obtain",
      "itemId": "cabbage-white",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Fishing Village Square East Pier of Fishing Village",
      "locationIds": [
        "fishing_village",
        "fishing-village-square"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ]
    }
  ],
  "cerulean-carpenter": [
    {
      "id": "cerulean-carpenter-obtain",
      "itemId": "cerulean-carpenter",
      "method": "BUG_CATCHING",
      "requiredLevel": 9,
      "habitat": "Fishing Village Square",
      "locationIds": [
        "fishing_village",
        "fishing-village-square"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "chestnut-tiger": [
    {
      "id": "chestnut-tiger-obtain",
      "itemId": "chestnut-tiger",
      "method": "BUG_CATCHING",
      "requiredLevel": 7,
      "habitat": "Bait the Insects",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "bait-the-insects",
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "cicada": [
    {
      "id": "cicada-obtain",
      "itemId": "cicada",
      "method": "BUG_CATCHING",
      "requiredLevel": 4,
      "habitat": "Spirit-Oak Pine Forest",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "comet-moth": [
    {
      "id": "comet-moth-obtain",
      "itemId": "comet-moth",
      "method": "BUG_CATCHING",
      "requiredLevel": 8,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "common-blue-butterfly": [
    {
      "id": "common-blue-butterfly-obtain",
      "itemId": "common-blue-butterfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 2,
      "habitat": "Central Square Art Street Garden Street Residential Street",
      "locationIds": [
        "art-street",
        "central-square",
        "garden-street",
        "residential-street"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "common-brimstone": [
    {
      "id": "common-brimstone-obtain",
      "itemId": "common-brimstone",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ]
    }
  ],
  "common-whitetail": [
    {
      "id": "common-whitetail-obtain",
      "itemId": "common-whitetail",
      "method": "BUG_CATCHING",
      "requiredLevel": 4,
      "habitat": "River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "conehead-mantis": [
    {
      "id": "conehead-mantis-obtain",
      "itemId": "conehead-mantis",
      "method": "BUG_CATCHING",
      "requiredLevel": 9,
      "habitat": "Ruins",
      "locationIds": [
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "crimson-marsh-glider": [
    {
      "id": "crimson-marsh-glider-obtain",
      "itemId": "crimson-marsh-glider",
      "method": "BUG_CATCHING",
      "requiredLevel": 7,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "elegant-flower-beetle": [
    {
      "id": "elegant-flower-beetle-obtain",
      "itemId": "elegant-flower-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 7,
      "habitat": "Whale Mountain",
      "locationIds": [
        "whale-mountain"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "european-firebug": [
    {
      "id": "european-firebug-obtain",
      "itemId": "european-firebug",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Residential Area",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ]
    }
  ],
  "fire-colored-beetle": [
    {
      "id": "fire-colored-beetle-obtain",
      "itemId": "fire-colored-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 3,
      "habitat": "Onsen Onsen Mountain Lake Crater Lake Ruins",
      "locationIds": [
        "crater-lake",
        "onsen-mountain",
        "onsen-mountain-lake",
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "four-spotted-ladybug": [
    {
      "id": "four-spotted-ladybug-obtain",
      "itemId": "four-spotted-ladybug",
      "method": "BUG_CATCHING",
      "requiredLevel": 4,
      "habitat": "Crater Lake",
      "locationIds": [
        "crater-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "four-spotted-skimmer": [
    {
      "id": "four-spotted-skimmer-obtain",
      "itemId": "four-spotted-skimmer",
      "method": "BUG_CATCHING",
      "requiredLevel": 2,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "frostspore-mother-of-pearl": [
    {
      "id": "frostspore-mother-of-pearl-obtain",
      "itemId": "frostspore-mother-of-pearl",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Frostspore Butterfly Spirit-Oak Pine Forest Forest Jump Puzzle",
      "locationIds": [
        "jump-puzzle"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "frostspore-butterfly-spirit-oak-pine-forest-forest-jump-puzzle",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "frostspore-postman-butterfly": [
    {
      "id": "frostspore-postman-butterfly-obtain",
      "itemId": "frostspore-postman-butterfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Frostspore Butterfly",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "frostspore-butterfly",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4930,
        2800,
        1500,
        450,
        320
      ]
    }
  ],
  "frostspore-purple-spotted-swallowtail": [
    {
      "id": "frostspore-purple-spotted-swallowtail-obtain",
      "itemId": "frostspore-purple-spotted-swallowtail",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Frostspore Butterfly Spirit-Oak Pine Forest",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "frostspore-butterfly-spirit-oak-pine-forest",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "frostspore-queen-alexandras-birdwing": [
    {
      "id": "frostspore-queen-alexandras-birdwing-obtain",
      "itemId": "frostspore-queen-alexandras-birdwing",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Frostspore Butterfly Deer Tower",
      "locationIds": [
        "deer-tower"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "frostspore-butterfly-deer-tower",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "frostspore-sulkowskys-morpho": [
    {
      "id": "frostspore-sulkowskys-morpho-obtain",
      "itemId": "frostspore-sulkowskys-morpho",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Frostspore Butterfly",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "frostspore-butterfly",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "giant-asian-mantis": [
    {
      "id": "giant-asian-mantis-obtain",
      "itemId": "giant-asian-mantis",
      "method": "BUG_CATCHING",
      "requiredLevel": 5,
      "habitat": "Ruins",
      "locationIds": [
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "gold-grasshopper": [
    {
      "id": "gold-grasshopper-obtain",
      "itemId": "gold-grasshopper",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ]
    }
  ],
  "golden-jewel-scarab": [
    {
      "id": "golden-jewel-scarab-obtain",
      "itemId": "golden-jewel-scarab",
      "method": "BUG_CATCHING",
      "requiredLevel": 7,
      "habitat": "Forest Jump Puzzle",
      "locationIds": [
        "jump-puzzle"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "golden-stag-beetle": [
    {
      "id": "golden-stag-beetle-obtain",
      "itemId": "golden-stag-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 9,
      "habitat": "Spirit-Oak Pine Forest",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "green-birdwing": [
    {
      "id": "green-birdwing-obtain",
      "itemId": "green-birdwing",
      "method": "BUG_CATCHING",
      "requiredLevel": 6,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "green-script-supervisor-bumblebee": [
    {
      "id": "green-script-supervisor-bumblebee-obtain",
      "itemId": "green-script-supervisor-bumblebee",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": "Amethyst Beach",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "green-tiger-beetle": [
    {
      "id": "green-tiger-beetle-obtain",
      "itemId": "green-tiger-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 2,
      "habitat": "Onsen Onsen Mountain Lake Crater Lake Ruins",
      "locationIds": [
        "crater-lake",
        "onsen-mountain",
        "onsen-mountain-lake",
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "hercules-beetle": [
    {
      "id": "hercules-beetle-obtain",
      "itemId": "hercules-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 10,
      "habitat": "Forest Deer Tower",
      "locationIds": [
        "deer-tower"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "horned-beetle": [
    {
      "id": "horned-beetle-obtain",
      "itemId": "horned-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 8,
      "habitat": "East Pier of Fishing Village",
      "locationIds": [
        "fishing_village"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "katydid": [
    {
      "id": "katydid-obtain",
      "itemId": "katydid",
      "method": "BUG_CATCHING",
      "requiredLevel": 3,
      "habitat": "Amethyst Beach",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "large-banded-grasshopper": [
    {
      "id": "large-banded-grasshopper-obtain",
      "itemId": "large-banded-grasshopper",
      "method": "BUG_CATCHING",
      "requiredLevel": 4,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "large-red-damselfly": [
    {
      "id": "large-red-damselfly-obtain",
      "itemId": "large-red-damselfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Lake River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ]
    }
  ],
  "mediterranean-mantis": [
    {
      "id": "mediterranean-mantis-obtain",
      "itemId": "mediterranean-mantis",
      "method": "BUG_CATCHING",
      "requiredLevel": 4,
      "habitat": "Stone Cliff",
      "locationIds": [
        "stone-cliff"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "mini-moon-moth": [
    {
      "id": "mini-moon-moth-obtain",
      "itemId": "mini-moon-moth",
      "method": "BUG_CATCHING",
      "requiredLevel": 3,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "minotaur-beetle": [
    {
      "id": "minotaur-beetle-obtain",
      "itemId": "minotaur-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 7,
      "habitat": "Ruins",
      "locationIds": [
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "NIGHT"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "morpho-helena": [
    {
      "id": "morpho-helena-obtain",
      "itemId": "morpho-helena",
      "method": "BUG_CATCHING",
      "requiredLevel": 10,
      "habitat": "Amethyst Beach",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "mother-of-pearl": [
    {
      "id": "mother-of-pearl-obtain",
      "itemId": "mother-of-pearl",
      "method": "BUG_CATCHING",
      "requiredLevel": 9,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "NIGHT"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "mourning-cloak": [
    {
      "id": "mourning-cloak-obtain",
      "itemId": "mourning-cloak",
      "method": "BUG_CATCHING",
      "requiredLevel": 5,
      "habitat": "Onsen",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "old-world-swallowtail": [
    {
      "id": "old-world-swallowtail-obtain",
      "itemId": "old-world-swallowtail",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Spirit-Oak Pine Forest Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ]
    }
  ],
  "orange-tip": [
    {
      "id": "orange-tip-obtain",
      "itemId": "orange-tip",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Central Square",
      "locationIds": [
        "central-square"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ]
    }
  ],
  "peacock-butterfly": [
    {
      "id": "peacock-butterfly-obtain",
      "itemId": "peacock-butterfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 5,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "picasso-bug": [
    {
      "id": "picasso-bug-obtain",
      "itemId": "picasso-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": 8,
      "habitat": "Amethyst Beach",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "pink-katydid": [
    {
      "id": "pink-katydid-obtain",
      "itemId": "pink-katydid",
      "method": "BUG_CATCHING",
      "requiredLevel": 3,
      "habitat": "Bait the Insects",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "bait-the-insects",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "pink-script-supervisor-bumblebee": [
    {
      "id": "pink-script-supervisor-bumblebee-obtain",
      "itemId": "pink-script-supervisor-bumblebee",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "postman-butterfly": [
    {
      "id": "postman-butterfly-obtain",
      "itemId": "postman-butterfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Bait the Insects",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "bait-the-insects",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        3000,
        1500,
        300,
        200
      ]
    }
  ],
  "purple-emperor": [
    {
      "id": "purple-emperor-obtain",
      "itemId": "purple-emperor",
      "method": "BUG_CATCHING",
      "requiredLevel": 3,
      "habitat": "Whale Mountain",
      "locationIds": [
        "whale-mountain"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "purple-script-supervisor-bumblebee": [
    {
      "id": "purple-script-supervisor-bumblebee-obtain",
      "itemId": "purple-script-supervisor-bumblebee",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "rainbow-stag-beetle": [
    {
      "id": "rainbow-stag-beetle-obtain",
      "itemId": "rainbow-stag-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 9,
      "habitat": "Bait the Insects Ruins",
      "locationIds": [
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "bait-the-insects-ruins",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "rajah-brookes-birdwing": [
    {
      "id": "rajah-brookes-birdwing-obtain",
      "itemId": "rajah-brookes-birdwing",
      "method": "BUG_CATCHING",
      "requiredLevel": 3,
      "habitat": "Residential Area",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "red-script-supervisor-bumblebee": [
    {
      "id": "red-script-supervisor-bumblebee-obtain",
      "itemId": "red-script-supervisor-bumblebee",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": "Whale Mountain",
      "locationIds": [
        "whale-mountain"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "seven-spotted-ladybug": [
    {
      "id": "seven-spotted-ladybug-obtain",
      "itemId": "seven-spotted-ladybug",
      "method": "BUG_CATCHING",
      "requiredLevel": 2,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "siberian-grasshopper": [
    {
      "id": "siberian-grasshopper-obtain",
      "itemId": "siberian-grasshopper",
      "method": "BUG_CATCHING",
      "requiredLevel": 2,
      "habitat": "Fishing Village Square East Pier of Fishing Village",
      "locationIds": [
        "fishing_village",
        "fishing-village-square"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "silver-jewel-scarab": [
    {
      "id": "silver-jewel-scarab-obtain",
      "itemId": "silver-jewel-scarab",
      "method": "BUG_CATCHING",
      "requiredLevel": 6,
      "habitat": "Stone Cliff",
      "locationIds": [
        "stone-cliff"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "spanish-moon-moth": [
    {
      "id": "spanish-moon-moth-obtain",
      "itemId": "spanish-moon-moth",
      "method": "BUG_CATCHING",
      "requiredLevel": 8,
      "habitat": "Spirit-Oak Pine Forest",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "splay-footed-carpenter": [
    {
      "id": "splay-footed-carpenter-obtain",
      "itemId": "splay-footed-carpenter",
      "method": "BUG_CATCHING",
      "requiredLevel": 5,
      "habitat": "Whale Mountain",
      "locationIds": [
        "whale-mountain"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "stag-beetle": [
    {
      "id": "stag-beetle-obtain",
      "itemId": "stag-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 6,
      "habitat": "Forest Jump Puzzle",
      "locationIds": [
        "jump-puzzle"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK"
      ],
      "starWeights": [
        4800,
        2200,
        1500,
        900,
        600
      ]
    }
  ],
  "sulkowskys-morpho": [
    {
      "id": "sulkowskys-morpho-obtain",
      "itemId": "sulkowskys-morpho",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": "Inflatable Insect Attractor",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "sunset-morpho": [
    {
      "id": "sunset-morpho-obtain",
      "itemId": "sunset-morpho",
      "method": "BUG_CATCHING",
      "requiredLevel": 10,
      "habitat": "Forest Deer Tower",
      "locationIds": [
        "deer-tower"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "waroona-cuckoo-bee": [
    {
      "id": "waroona-cuckoo-bee-obtain",
      "itemId": "waroona-cuckoo-bee",
      "method": "BUG_CATCHING",
      "requiredLevel": 3,
      "habitat": "Deer Tower",
      "locationIds": [
        "deer-tower"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "wasp-beetle": [
    {
      "id": "wasp-beetle-obtain",
      "itemId": "wasp-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 2,
      "habitat": "Spirit-Oak Pine Forest Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "white-witch": [
    {
      "id": "white-witch-obtain",
      "itemId": "white-witch",
      "method": "BUG_CATCHING",
      "requiredLevel": 5,
      "habitat": "Bait the Insects",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "bait-the-insects",
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "african-olive-pigeon": [
    {
      "id": "african-olive-pigeon-obtain",
      "itemId": "african-olive-pigeon",
      "method": "BIRDWATCHING",
      "requiredLevel": 5,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "american-flamingo": [
    {
      "id": "american-flamingo-obtain",
      "itemId": "american-flamingo",
      "method": "BIRDWATCHING",
      "requiredLevel": 9,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY"
      ]
    }
  ],
  "amur-falcon": [
    {
      "id": "amur-falcon-obtain",
      "itemId": "amur-falcon",
      "method": "BIRDWATCHING",
      "requiredLevel": 10,
      "habitat": "Ruins",
      "locationIds": [
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "audouins-gull": [
    {
      "id": "audouins-gull-obtain",
      "itemId": "audouins-gull",
      "method": "BIRDWATCHING",
      "requiredLevel": 3,
      "habitat": "Whale Sea",
      "locationIds": [
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "azores-bullfinch": [
    {
      "id": "azores-bullfinch-obtain",
      "itemId": "azores-bullfinch",
      "method": "BIRDWATCHING",
      "requiredLevel": 10,
      "habitat": "East Pier of Fishing Village",
      "locationIds": [
        "fishing_village"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "azure-tit": [
    {
      "id": "azure-tit-obtain",
      "itemId": "azure-tit",
      "method": "BIRDWATCHING",
      "requiredLevel": 7,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "bearded-reedling": [
    {
      "id": "bearded-reedling-obtain",
      "itemId": "bearded-reedling",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Onsen Onsen Mountain Lake Crater Lake Ruins",
      "locationIds": [
        "crater-lake",
        "onsen-mountain",
        "onsen-mountain-lake",
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "blue-and-yellow-macaw": [
    {
      "id": "blue-and-yellow-macaw-obtain",
      "itemId": "blue-and-yellow-macaw",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Nest of Hundreds",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "nest-of-hundreds",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "blue-peafowl": [
    {
      "id": "blue-peafowl-obtain",
      "itemId": "blue-peafowl",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Nest of Hundreds",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "nest-of-hundreds",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "brown-noddy": [
    {
      "id": "brown-noddy-obtain",
      "itemId": "brown-noddy",
      "method": "BIRDWATCHING",
      "requiredLevel": 5,
      "habitat": "Old Sea",
      "locationIds": [
        "old-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "cinnamon-ground-dove": [
    {
      "id": "cinnamon-ground-dove-obtain",
      "itemId": "cinnamon-ground-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 6,
      "habitat": "Fishing Village Square",
      "locationIds": [
        "fishing_village",
        "fishing-village-square"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "common-kestrel": [
    {
      "id": "common-kestrel-obtain",
      "itemId": "common-kestrel",
      "method": "BIRDWATCHING",
      "requiredLevel": 7,
      "habitat": "Deer Tower",
      "locationIds": [
        "deer-tower"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "double-barred-finch": [
    {
      "id": "double-barred-finch-obtain",
      "itemId": "double-barred-finch",
      "method": "BIRDWATCHING",
      "requiredLevel": 3,
      "habitat": "East Pier of Fishing Village",
      "locationIds": [
        "fishing_village"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "eagle-owl": [
    {
      "id": "eagle-owl-obtain",
      "itemId": "eagle-owl",
      "method": "BIRDWATCHING",
      "requiredLevel": 10,
      "habitat": "Deer Tower",
      "locationIds": [
        "deer-tower"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "eastern-bluebird": [
    {
      "id": "eastern-bluebird-obtain",
      "itemId": "eastern-bluebird",
      "method": "BIRDWATCHING",
      "requiredLevel": 8,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "eurasian-bullfinch": [
    {
      "id": "eurasian-bullfinch-obtain",
      "itemId": "eurasian-bullfinch",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "eurasian-chaffinch": [
    {
      "id": "eurasian-chaffinch-obtain",
      "itemId": "eurasian-chaffinch",
      "method": "BIRDWATCHING",
      "requiredLevel": 2,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "eurasian-collared-dove": [
    {
      "id": "eurasian-collared-dove-obtain",
      "itemId": "eurasian-collared-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Residential Area",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "eurasian-golden-oriole": [
    {
      "id": "eurasian-golden-oriole-obtain",
      "itemId": "eurasian-golden-oriole",
      "method": "BIRDWATCHING",
      "requiredLevel": 3,
      "habitat": "Rosy River",
      "locationIds": [
        "rosy-river"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "eurasian-nuthatch": [
    {
      "id": "eurasian-nuthatch-obtain",
      "itemId": "eurasian-nuthatch",
      "method": "BIRDWATCHING",
      "requiredLevel": 2,
      "habitat": "Fishing Village Square East Pier of Fishing Village",
      "locationIds": [
        "fishing_village",
        "fishing-village-square"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "eurasian-wigeon": [
    {
      "id": "eurasian-wigeon-obtain",
      "itemId": "eurasian-wigeon",
      "method": "BIRDWATCHING",
      "requiredLevel": 2,
      "habitat": "River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "eurasian-wren": [
    {
      "id": "eurasian-wren-obtain",
      "itemId": "eurasian-wren",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Spirit-Oak Pine Forest Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "european-bee-eater": [
    {
      "id": "european-bee-eater-obtain",
      "itemId": "european-bee-eater",
      "method": "BIRDWATCHING",
      "requiredLevel": 5,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "european-robin": [
    {
      "id": "european-robin-obtain",
      "itemId": "european-robin",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Central Square",
      "locationIds": [
        "central-square"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "european-shag": [
    {
      "id": "european-shag-obtain",
      "itemId": "european-shag",
      "method": "BIRDWATCHING",
      "requiredLevel": 3,
      "habitat": "Forest Island",
      "locationIds": [
        "forest-island"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "great-green-macaw": [
    {
      "id": "great-green-macaw-obtain",
      "itemId": "great-green-macaw",
      "method": "BIRDWATCHING",
      "requiredLevel": 5,
      "habitat": "Nest of Hundreds",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "nest-of-hundreds",
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "great-tit": [
    {
      "id": "great-tit-obtain",
      "itemId": "great-tit",
      "method": "BIRDWATCHING",
      "requiredLevel": 2,
      "habitat": "Crater Lake Ruins",
      "locationIds": [
        "crater-lake",
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "greater-flamingo": [
    {
      "id": "greater-flamingo-obtain",
      "itemId": "greater-flamingo",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "hawfinch": [
    {
      "id": "hawfinch-obtain",
      "itemId": "hawfinch",
      "method": "BIRDWATCHING",
      "requiredLevel": 6,
      "habitat": "Crater Lake",
      "locationIds": [
        "crater-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "imperial-shag": [
    {
      "id": "imperial-shag-obtain",
      "itemId": "imperial-shag",
      "method": "BIRDWATCHING",
      "requiredLevel": 9,
      "habitat": "East Sea Zephyr Sea",
      "locationIds": [
        "east-sea",
        "zephyr-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "jambu-fruit-dove": [
    {
      "id": "jambu-fruit-dove-obtain",
      "itemId": "jambu-fruit-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 7,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "king-eider": [
    {
      "id": "king-eider-obtain",
      "itemId": "king-eider",
      "method": "BIRDWATCHING",
      "requiredLevel": 3,
      "habitat": "River",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "lady-amherst-pheasant": [
    {
      "id": "lady-amherst-pheasant-obtain",
      "itemId": "lady-amherst-pheasant",
      "method": "BIRDWATCHING",
      "requiredLevel": 4,
      "habitat": "Ruins",
      "locationIds": [
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "lears-macaw": [
    {
      "id": "lears-macaw-obtain",
      "itemId": "lears-macaw",
      "method": "BIRDWATCHING",
      "requiredLevel": 7,
      "habitat": "Nest of Hundreds",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "nest-of-hundreds",
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "lesser-flamingo": [
    {
      "id": "lesser-flamingo-obtain",
      "itemId": "lesser-flamingo",
      "method": "BIRDWATCHING",
      "requiredLevel": 5,
      "habitat": "Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "long-eared-owl": [
    {
      "id": "long-eared-owl-obtain",
      "itemId": "long-eared-owl",
      "method": "BIRDWATCHING",
      "requiredLevel": 6,
      "habitat": "Stone Cliff",
      "locationIds": [
        "stone-cliff"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "long-tailed-tit": [
    {
      "id": "long-tailed-tit-obtain",
      "itemId": "long-tailed-tit",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Blanc's Head",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "mallard": [
    {
      "id": "mallard-obtain",
      "itemId": "mallard",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "paradise-tanager": [
    {
      "id": "paradise-tanager-obtain",
      "itemId": "paradise-tanager",
      "method": "BIRDWATCHING",
      "requiredLevel": 9,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "peregrine-falcon": [
    {
      "id": "peregrine-falcon-obtain",
      "itemId": "peregrine-falcon",
      "method": "BIRDWATCHING",
      "requiredLevel": 7,
      "habitat": "Stone Cliff Onsen Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake",
        "stone-cliff"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "pied-imperial-pigeon": [
    {
      "id": "pied-imperial-pigeon-obtain",
      "itemId": "pied-imperial-pigeon",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Fishing Village Square East Pier of Fishing Village Wharf",
      "locationIds": [
        "fishing_village",
        "fishing-village-square",
        "wharf"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "pine-grosbeak": [
    {
      "id": "pine-grosbeak-obtain",
      "itemId": "pine-grosbeak",
      "method": "BIRDWATCHING",
      "requiredLevel": 4,
      "habitat": "Forest Island",
      "locationIds": [
        "forest-island"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "pink-necked-green-pigeon": [
    {
      "id": "pink-necked-green-pigeon-obtain",
      "itemId": "pink-necked-green-pigeon",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "pink-pigeon": [
    {
      "id": "pink-pigeon-obtain",
      "itemId": "pink-pigeon",
      "method": "BIRDWATCHING",
      "requiredLevel": 7,
      "habitat": "Whale Mountain",
      "locationIds": [
        "whale-mountain"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "przevalskis-parrotbill": [
    {
      "id": "przevalskis-parrotbill-obtain",
      "itemId": "przevalskis-parrotbill",
      "method": "BIRDWATCHING",
      "requiredLevel": 4,
      "habitat": "Fishing Village Square",
      "locationIds": [
        "fishing_village",
        "fishing-village-square"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "red-and-green-macaw": [
    {
      "id": "red-and-green-macaw-obtain",
      "itemId": "red-and-green-macaw",
      "method": "BIRDWATCHING",
      "requiredLevel": 3,
      "habitat": "Nest of Hundreds",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "nest-of-hundreds",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "red-faced-cormorant": [
    {
      "id": "red-faced-cormorant-obtain",
      "itemId": "red-faced-cormorant",
      "method": "BIRDWATCHING",
      "requiredLevel": 6,
      "habitat": "Old Sea Whale Sea",
      "locationIds": [
        "old-sea",
        "whale-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "redpoll": [
    {
      "id": "redpoll-obtain",
      "itemId": "redpoll",
      "method": "BIRDWATCHING",
      "requiredLevel": 8,
      "habitat": "Spirit-Oak Pine Forest",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "regent-bowerbird": [
    {
      "id": "regent-bowerbird-obtain",
      "itemId": "regent-bowerbird",
      "method": "BIRDWATCHING",
      "requiredLevel": 4,
      "habitat": "Spirit-Oak Pine Forest",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "ruddy-shelduck": [
    {
      "id": "ruddy-shelduck-obtain",
      "itemId": "ruddy-shelduck",
      "method": "BIRDWATCHING",
      "requiredLevel": 3,
      "habitat": "Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "seagull": [
    {
      "id": "seagull-obtain",
      "itemId": "seagull",
      "method": "BIRDWATCHING",
      "requiredLevel": 2,
      "habitat": "Seaside",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "silver-throated-tit": [
    {
      "id": "silver-throated-tit-obtain",
      "itemId": "silver-throated-tit",
      "method": "BIRDWATCHING",
      "requiredLevel": 3,
      "habitat": "Forest Jump Puzzle",
      "locationIds": [
        "jump-puzzle"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "smew": [
    {
      "id": "smew-obtain",
      "itemId": "smew",
      "method": "BIRDWATCHING",
      "requiredLevel": 4,
      "habitat": "Forest Lake",
      "locationIds": [
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "stock-dove": [
    {
      "id": "stock-dove-obtain",
      "itemId": "stock-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 2,
      "habitat": "Central Square",
      "locationIds": [
        "central-square"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "tern": [
    {
      "id": "tern-obtain",
      "itemId": "tern",
      "method": "BIRDWATCHING",
      "requiredLevel": 7,
      "habitat": "East Sea Seaside",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "verditer-flycatcher": [
    {
      "id": "verditer-flycatcher-obtain",
      "itemId": "verditer-flycatcher",
      "method": "BIRDWATCHING",
      "requiredLevel": 10,
      "habitat": "Forest Jump Puzzle",
      "locationIds": [
        "jump-puzzle"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "wallaces-fruit-dove": [
    {
      "id": "wallaces-fruit-dove-obtain",
      "itemId": "wallaces-fruit-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 4,
      "habitat": "Windmill Flower Field",
      "locationIds": [
        "windmill-flower-field"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "white-headed-duck": [
    {
      "id": "white-headed-duck-obtain",
      "itemId": "white-headed-duck",
      "method": "BIRDWATCHING",
      "requiredLevel": 9,
      "habitat": "Onsen Mountain Lake",
      "locationIds": [
        "onsen-mountain",
        "onsen-mountain-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "white-wagtail": [
    {
      "id": "white-wagtail-obtain",
      "itemId": "white-wagtail",
      "method": "BIRDWATCHING",
      "requiredLevel": 4,
      "habitat": "Amethyst Beach",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "winter-eurasian-wigeon": [
    {
      "id": "winter-eurasian-wigeon-obtain",
      "itemId": "winter-eurasian-wigeon",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Winter Birdwatching Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "winter-birdwatching-suburban-lake",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "winter-greater-flamingo": [
    {
      "id": "winter-greater-flamingo-obtain",
      "itemId": "winter-greater-flamingo",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Winter Birdwatching Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "winter-birdwatching-suburban-lake",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "winter-mallard": [
    {
      "id": "winter-mallard-obtain",
      "itemId": "winter-mallard",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Winter Birdwatching Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "winter-birdwatching-suburban-lake",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "winter-mandarin-duck": [
    {
      "id": "winter-mandarin-duck-obtain",
      "itemId": "winter-mandarin-duck",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Winter Birdwatching",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "winter-birdwatching",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "winter-smew": [
    {
      "id": "winter-smew-obtain",
      "itemId": "winter-smew",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Winter Birdwatching Suburban Lake",
      "locationIds": [
        "suburban-lake"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "winter-birdwatching-suburban-lake",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "wonga-pigeon": [
    {
      "id": "wonga-pigeon-obtain",
      "itemId": "wonga-pigeon",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": "Spirit-Oak Pine Forest Deer Tower Forest Lake",
      "locationIds": [
        "deer-tower",
        "forest-lake"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "woodchat-shrike": [
    {
      "id": "woodchat-shrike-obtain",
      "itemId": "woodchat-shrike",
      "method": "BIRDWATCHING",
      "requiredLevel": 2,
      "habitat": "Suburbs",
      "locationIds": [
        "suburbs"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "yellow-bellied-flycatcher": [
    {
      "id": "yellow-bellied-flycatcher-obtain",
      "itemId": "yellow-bellied-flycatcher",
      "method": "BIRDWATCHING",
      "requiredLevel": 5,
      "habitat": "Wharf",
      "locationIds": [
        "wharf"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "avocado": [
    {
      "id": "avocado-obtain",
      "itemId": "avocado",
      "method": "FARMING",
      "requiredLevel": 13,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": 1440,
      "seedBuyPrice": 180,
      "seedSellPrice": null
    }
  ],
  "cacao": [
    {
      "id": "cacao-obtain",
      "itemId": "cacao",
      "method": "FARMING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": 300,
      "seedBuyPrice": 110,
      "seedSellPrice": null
    }
  ],
  "carrot": [
    {
      "id": "carrot-obtain",
      "itemId": "carrot",
      "method": "FARMING",
      "requiredLevel": 5,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [
        "spring",
        "summer",
        "fall"
      ],
      "growthTimeMinutes": 120,
      "seedBuyPrice": 50,
      "seedSellPrice": 25
    }
  ],
  "corn": [
    {
      "id": "corn-obtain",
      "itemId": "corn",
      "method": "FARMING",
      "requiredLevel": 6,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [
        "summer",
        "fall"
      ],
      "growthTimeMinutes": 720,
      "seedBuyPrice": 170,
      "seedSellPrice": null
    }
  ],
  "eggplant": [
    {
      "id": "eggplant-obtain",
      "itemId": "eggplant",
      "method": "FARMING",
      "requiredLevel": 8,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": 300,
      "seedBuyPrice": 135,
      "seedSellPrice": null
    }
  ],
  "grape": [
    {
      "id": "grape-obtain",
      "itemId": "grape",
      "method": "FARMING",
      "requiredLevel": 7,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": 600,
      "seedBuyPrice": 160,
      "seedSellPrice": null
    }
  ],
  "lettuce": [
    {
      "id": "lettuce-obtain",
      "itemId": "lettuce",
      "method": "FARMING",
      "requiredLevel": 3,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [
        "spring",
        "summer",
        "fall"
      ],
      "growthTimeMinutes": 480,
      "seedBuyPrice": 145,
      "seedSellPrice": 72
    }
  ],
  "paddy": [
    {
      "id": "paddy-obtain",
      "itemId": "paddy",
      "method": "FARMING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": 20,
      "seedBuyPrice": 12,
      "seedSellPrice": null
    }
  ],
  "pineapple": [
    {
      "id": "pineapple-obtain",
      "itemId": "pineapple",
      "method": "FARMING",
      "requiredLevel": 4,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": 30,
      "seedBuyPrice": 15,
      "seedSellPrice": 7
    }
  ],
  "potatoes": [
    {
      "id": "potatoes-obtain",
      "itemId": "potatoes",
      "method": "FARMING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": 60,
      "seedBuyPrice": 30,
      "seedSellPrice": 15
    }
  ],
  "romaine-lettuce": [
    {
      "id": "romaine-lettuce-obtain",
      "itemId": "romaine-lettuce",
      "method": "FARMING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": 15,
      "seedBuyPrice": 10,
      "seedSellPrice": null
    }
  ],
  "strawberry": [
    {
      "id": "strawberry-obtain",
      "itemId": "strawberry",
      "method": "FARMING",
      "requiredLevel": 6,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": 360,
      "seedBuyPrice": 125,
      "seedSellPrice": null
    }
  ],
  "tea": [
    {
      "id": "tea-obtain",
      "itemId": "tea",
      "method": "FARMING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": null,
      "seedBuyPrice": 25,
      "seedSellPrice": null
    }
  ],
  "tomato": [
    {
      "id": "tomato-obtain",
      "itemId": "tomato",
      "method": "FARMING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [
        "spring",
        "summer",
        "fall"
      ],
      "growthTimeMinutes": 15,
      "seedBuyPrice": 10,
      "seedSellPrice": 5
    }
  ],
  "wheat": [
    {
      "id": "wheat-obtain",
      "itemId": "wheat",
      "method": "FARMING",
      "requiredLevel": 2,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [
        "spring",
        "summer"
      ],
      "growthTimeMinutes": 240,
      "seedBuyPrice": 95,
      "seedSellPrice": 47
    }
  ],
  "white-radish": [
    {
      "id": "white-radish-obtain",
      "itemId": "white-radish",
      "method": "FARMING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seasons": [],
      "growthTimeMinutes": 15,
      "seedBuyPrice": 10,
      "seedSellPrice": null
    }
  ],
  "anthurium": [
    {
      "id": "anthurium-obtain",
      "itemId": "anthurium",
      "method": "FARMING",
      "requiredLevel": 5,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 60
    }
  ],
  "calla-lily": [
    {
      "id": "calla-lily-obtain",
      "itemId": "calla-lily",
      "method": "FARMING",
      "requiredLevel": 6,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 300
    }
  ],
  "carnation": [
    {
      "id": "carnation-obtain",
      "itemId": "carnation",
      "method": "FARMING",
      "requiredLevel": 7,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 120
    }
  ],
  "corn-poppy": [
    {
      "id": "corn-poppy-obtain",
      "itemId": "corn-poppy",
      "method": "FARMING",
      "requiredLevel": 5,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 60
    }
  ],
  "cranesbill": [
    {
      "id": "cranesbill-obtain",
      "itemId": "cranesbill",
      "method": "FARMING",
      "requiredLevel": 13,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": null
    }
  ],
  "daisy": [
    {
      "id": "daisy-obtain",
      "itemId": "daisy",
      "method": "FARMING",
      "requiredLevel": 3,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 30
    }
  ],
  "dandelion": [
    {
      "id": "dandelion-obtain",
      "itemId": "dandelion",
      "method": "FARMING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": null
    }
  ],
  "highland-poppy": [
    {
      "id": "highland-poppy-obtain",
      "itemId": "highland-poppy",
      "method": "FARMING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": null
    }
  ],
  "hyacinth": [
    {
      "id": "hyacinth-obtain",
      "itemId": "hyacinth",
      "method": "FARMING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 300
    }
  ],
  "laceleaf": [
    {
      "id": "laceleaf-obtain",
      "itemId": "laceleaf",
      "method": "FARMING",
      "requiredLevel": 5,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 60
    }
  ],
  "lily": [
    {
      "id": "lily-obtain",
      "itemId": "lily",
      "method": "FARMING",
      "requiredLevel": 9,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 200
    }
  ],
  "morning-glory": [
    {
      "id": "morning-glory-obtain",
      "itemId": "morning-glory",
      "method": "FARMING",
      "requiredLevel": 6,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 90
    }
  ],
  "moth-orchid": [
    {
      "id": "moth-orchid-obtain",
      "itemId": "moth-orchid",
      "method": "FARMING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 300
    }
  ],
  "pansy": [
    {
      "id": "pansy-obtain",
      "itemId": "pansy",
      "method": "FARMING",
      "requiredLevel": 4,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 30
    }
  ],
  "rose": [
    {
      "id": "rose-obtain",
      "itemId": "rose",
      "method": "FARMING",
      "requiredLevel": 10,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 300
    }
  ],
  "tulip": [
    {
      "id": "tulip-obtain",
      "itemId": "tulip",
      "method": "FARMING",
      "requiredLevel": 8,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "seedBuyPrice": 150
    }
  ],
  "apple": [
    {
      "id": "apple-obtain",
      "itemId": "apple",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Área Residencial Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bamboo": [
    {
      "id": "bamboo-obtain",
      "itemId": "bamboo",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Forest Jump Puzzle",
      "locationIds": [
        "jump-puzzle"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-button-mushroom-blue": [
    {
      "id": "bizarre-button-mushroom-blue-obtain",
      "itemId": "bizarre-button-mushroom-blue",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Windmill Flower Field Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-button-mushroom-green": [
    {
      "id": "bizarre-button-mushroom-green-obtain",
      "itemId": "bizarre-button-mushroom-green",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Windmill Flower Field Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-button-mushroom-red": [
    {
      "id": "bizarre-button-mushroom-red-obtain",
      "itemId": "bizarre-button-mushroom-red",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Windmill Flower Field Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-oyster-mushroom-orange": [
    {
      "id": "bizarre-oyster-mushroom-orange-obtain",
      "itemId": "bizarre-oyster-mushroom-orange",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Lago del monte termal Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-oyster-mushroom-pink": [
    {
      "id": "bizarre-oyster-mushroom-pink-obtain",
      "itemId": "bizarre-oyster-mushroom-pink",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Lago del monte termal Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-oyster-mushroom-purple": [
    {
      "id": "bizarre-oyster-mushroom-purple-obtain",
      "itemId": "bizarre-oyster-mushroom-purple",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Lago del monte termal Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-penny-bun-pink": [
    {
      "id": "bizarre-penny-bun-pink-obtain",
      "itemId": "bizarre-penny-bun-pink",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Bosque de roble espiritual Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-penny-bun-purple": [
    {
      "id": "bizarre-penny-bun-purple-obtain",
      "itemId": "bizarre-penny-bun-purple",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Bosque de roble espiritual Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-penny-bun-red": [
    {
      "id": "bizarre-penny-bun-red-obtain",
      "itemId": "bizarre-penny-bun-red",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Bosque de roble espiritual Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-shiitake-blue": [
    {
      "id": "bizarre-shiitake-blue-obtain",
      "itemId": "bizarre-shiitake-blue",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Fishing Village Square Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-shiitake-black": [
    {
      "id": "bizarre-shiitake-black-obtain",
      "itemId": "bizarre-shiitake-black",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Fishing Village Square Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "bizarre-shiitake-red": [
    {
      "id": "bizarre-shiitake-red-obtain",
      "itemId": "bizarre-shiitake-red",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Fishing Village Square Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "black-truffle": [
    {
      "id": "black-truffle-obtain",
      "itemId": "black-truffle",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Forest Island Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "blueberry": [
    {
      "id": "blueberry-obtain",
      "itemId": "blueberry",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Área Residencial Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "branch": [
    {
      "id": "branch-obtain",
      "itemId": "branch",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Área Residencial Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "burdock": [
    {
      "id": "burdock-obtain",
      "itemId": "burdock",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Whale Mountain",
      "locationIds": [
        "whale-mountain"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "button-mushroom": [
    {
      "id": "button-mushroom-obtain",
      "itemId": "button-mushroom",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Windmill Flower Field Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "fiddlehead": [
    {
      "id": "fiddlehead-obtain",
      "itemId": "fiddlehead",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Deer Tower",
      "locationIds": [
        "deer-tower"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "mandarin": [
    {
      "id": "mandarin-obtain",
      "itemId": "mandarin",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Área Residencial Gathering",
      "locationIds": [
        "residential-street"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "matsutake": [
    {
      "id": "matsutake-obtain",
      "itemId": "matsutake",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Estanque Sombreado Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "mustard-greens": [
    {
      "id": "mustard-greens-obtain",
      "itemId": "mustard-greens",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Lighthouse",
      "locationIds": [
        "lighthouse"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "oyster-mushroom": [
    {
      "id": "oyster-mushroom-obtain",
      "itemId": "oyster-mushroom",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Lago del monte termal Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "penny-bun": [
    {
      "id": "penny-bun-obtain",
      "itemId": "penny-bun",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Bosque de roble espiritual Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "raspberry": [
    {
      "id": "raspberry-obtain",
      "itemId": "raspberry",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Windmill Flower Field Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "shiitake": [
    {
      "id": "shiitake-obtain",
      "itemId": "shiitake",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Fishing Village Square Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "tall-mustard": [
    {
      "id": "tall-mustard-obtain",
      "itemId": "tall-mustard",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Ruins",
      "locationIds": [
        "ruins"
      ],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "weed": [
    {
      "id": "weed-obtain",
      "itemId": "weed",
      "method": "FORAGING",
      "requiredLevel": null,
      "habitat": "Main Zone Área Residencial Gathering",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null
    }
  ],
  "apple-verbena-pie": [
    {
      "id": "apple-verbena-pie-crafting",
      "itemId": "apple-verbena-pie",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "blueberry-verbena-pie": [
    {
      "id": "blueberry-verbena-pie-crafting",
      "itemId": "blueberry-verbena-pie",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-black-truffle-patty-burger": [
    {
      "id": "brick-black-truffle-patty-burger-crafting",
      "itemId": "brick-black-truffle-patty-burger",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-bowl-apple-shaved-ice": [
    {
      "id": "brick-bowl-apple-shaved-ice-crafting",
      "itemId": "brick-bowl-apple-shaved-ice",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-bowl-blueberry-shaved-ice": [
    {
      "id": "brick-bowl-blueberry-shaved-ice-crafting",
      "itemId": "brick-bowl-blueberry-shaved-ice",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-bowl-fruit-shaved-ice": [
    {
      "id": "brick-bowl-fruit-shaved-ice-crafting",
      "itemId": "brick-bowl-fruit-shaved-ice",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-bowl-grape-shaved-ice": [
    {
      "id": "brick-bowl-grape-shaved-ice-crafting",
      "itemId": "brick-bowl-grape-shaved-ice",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-bowl-mandarin-shaved-ice": [
    {
      "id": "brick-bowl-mandarin-shaved-ice-crafting",
      "itemId": "brick-bowl-mandarin-shaved-ice",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-bowl-pineapple-shaved-ice": [
    {
      "id": "brick-bowl-pineapple-shaved-ice-crafting",
      "itemId": "brick-bowl-pineapple-shaved-ice",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-bowl-raspberry-shaved-ice": [
    {
      "id": "brick-bowl-raspberry-shaved-ice-crafting",
      "itemId": "brick-bowl-raspberry-shaved-ice",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-bowl-strawberry-shaved-ice": [
    {
      "id": "brick-bowl-strawberry-shaved-ice-crafting",
      "itemId": "brick-bowl-strawberry-shaved-ice",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-button-mushroom-patty-burger": [
    {
      "id": "brick-button-mushroom-patty-burger-crafting",
      "itemId": "brick-button-mushroom-patty-burger",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-fun-combo-set": [
    {
      "id": "brick-fun-combo-set-crafting",
      "itemId": "brick-fun-combo-set",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-mushroom-patty-burger": [
    {
      "id": "brick-mushroom-patty-burger-crafting",
      "itemId": "brick-mushroom-patty-burger",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-oyster-mushroom-patty-burger": [
    {
      "id": "brick-oyster-mushroom-patty-burger-crafting",
      "itemId": "brick-oyster-mushroom-patty-burger",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-penny-bun-patty-burger": [
    {
      "id": "brick-penny-bun-patty-burger-crafting",
      "itemId": "brick-penny-bun-patty-burger",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "brick-shiitake-patty-burger": [
    {
      "id": "brick-shiitake-patty-burger-crafting",
      "itemId": "brick-shiitake-patty-burger",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "colorful-egg-feast": [
    {
      "id": "colorful-egg-feast-crafting",
      "itemId": "colorful-egg-feast",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "fruit-verbena-pie": [
    {
      "id": "fruit-verbena-pie-crafting",
      "itemId": "fruit-verbena-pie",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "grape-verbena-pie": [
    {
      "id": "grape-verbena-pie-crafting",
      "itemId": "grape-verbena-pie",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "grass-cake": [
    {
      "id": "grass-cake-crafting",
      "itemId": "grass-cake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "green-egg": [
    {
      "id": "green-egg-crafting",
      "itemId": "green-egg",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "heart-puppies-con-panna": [
    {
      "id": "heart-puppies-con-panna-crafting",
      "itemId": "heart-puppies-con-panna",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "maltese",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "maltese-canele": [
    {
      "id": "maltese-canele-crafting",
      "itemId": "maltese-canele",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "maltese",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "maltese-con-panna": [
    {
      "id": "maltese-con-panna-crafting",
      "itemId": "maltese-con-panna",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "maltese",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "mandarin-verbena-pie": [
    {
      "id": "mandarin-verbena-pie-crafting",
      "itemId": "mandarin-verbena-pie",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "orange-egg": [
    {
      "id": "orange-egg-crafting",
      "itemId": "orange-egg",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "pillow-shaped-egg-yolk-and-pork-zongzi": [
    {
      "id": "pillow-shaped-egg-yolk-and-pork-zongzi-crafting",
      "itemId": "pillow-shaped-egg-yolk-and-pork-zongzi",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "midsummer-rhyme",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "pillow-shaped-plain-rice-zongzi": [
    {
      "id": "pillow-shaped-plain-rice-zongzi-crafting",
      "itemId": "pillow-shaped-plain-rice-zongzi",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "midsummer-rhyme",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "pillow-shaped-red-bean-zongzi": [
    {
      "id": "pillow-shaped-red-bean-zongzi-crafting",
      "itemId": "pillow-shaped-red-bean-zongzi",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "midsummer-rhyme",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "pineapple-verbena-pie": [
    {
      "id": "pineapple-verbena-pie-crafting",
      "itemId": "pineapple-verbena-pie",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "purple-egg": [
    {
      "id": "purple-egg-crafting",
      "itemId": "purple-egg",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "rainbow-heart": [
    {
      "id": "rainbow-heart-crafting",
      "itemId": "rainbow-heart",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "rainbow-verse",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "rainbow-spark": [
    {
      "id": "rainbow-spark-crafting",
      "itemId": "rainbow-spark",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "rainbow-verse",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "raspberry-verbena-pie": [
    {
      "id": "raspberry-verbena-pie-crafting",
      "itemId": "raspberry-verbena-pie",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "retriever-canele": [
    {
      "id": "retriever-canele-crafting",
      "itemId": "retriever-canele",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "maltese",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "retriever-con-panna": [
    {
      "id": "retriever-con-panna-crafting",
      "itemId": "retriever-con-panna",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "maltese",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "springdag-raspberry-black-tea": [
    {
      "id": "springdag-raspberry-black-tea-crafting",
      "itemId": "springdag-raspberry-black-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "springday-apple-black-tea": [
    {
      "id": "springday-apple-black-tea-crafting",
      "itemId": "springday-apple-black-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "springday-blueberry-black-tea": [
    {
      "id": "springday-blueberry-black-tea-crafting",
      "itemId": "springday-blueberry-black-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "springday-fruit-black-tea": [
    {
      "id": "springday-fruit-black-tea-crafting",
      "itemId": "springday-fruit-black-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "springday-grape-black-tea": [
    {
      "id": "springday-grape-black-tea-crafting",
      "itemId": "springday-grape-black-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "springday-mandarin-black-tea": [
    {
      "id": "springday-mandarin-black-tea-crafting",
      "itemId": "springday-mandarin-black-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "springday-pineapple-black-tea": [
    {
      "id": "springday-pineapple-black-tea-crafting",
      "itemId": "springday-pineapple-black-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "springday-strawberry-black-tea": [
    {
      "id": "springday-strawberry-black-tea-crafting",
      "itemId": "springday-strawberry-black-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "strawberry-jam": [
    {
      "id": "strawberry-jam-crafting",
      "itemId": "strawberry-jam",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "strawberry-verbena-pie": [
    {
      "id": "strawberry-verbena-pie-crafting",
      "itemId": "strawberry-verbena-pie",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "supreme-movie-meal": [
    {
      "id": "supreme-movie-meal-crafting",
      "itemId": "supreme-movie-meal",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "triangle-egg-yolk-and-pork-zongzi": [
    {
      "id": "triangle-egg-yolk-and-pork-zongzi-crafting",
      "itemId": "triangle-egg-yolk-and-pork-zongzi",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "midsummer-rhyme",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "triangle-plain-rice-zongzi": [
    {
      "id": "triangle-plain-rice-zongzi-crafting",
      "itemId": "triangle-plain-rice-zongzi",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "midsummer-rhyme",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "triangle-red-bean-zongzi": [
    {
      "id": "triangle-red-bean-zongzi-crafting",
      "itemId": "triangle-red-bean-zongzi",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "midsummer-rhyme",
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "blue-european-crayfish-sashimi": [
    {
      "id": "blue-european-crayfish-sashimi-crafting",
      "itemId": "blue-european-crayfish-sashimi",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "steamed-golden-king-crab": [
    {
      "id": "steamed-golden-king-crab-crafting",
      "itemId": "steamed-golden-king-crab",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "steamed-king-crab": [
    {
      "id": "steamed-king-crab-crafting",
      "itemId": "steamed-king-crab",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "apple-milkshake": [
    {
      "id": "apple-milkshake-crafting",
      "itemId": "apple-milkshake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "blueberry-milkshake": [
    {
      "id": "blueberry-milkshake-crafting",
      "itemId": "blueberry-milkshake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "cocoa-milk-tea": [
    {
      "id": "cocoa-milk-tea-crafting",
      "itemId": "cocoa-milk-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "cocoa-milkshake": [
    {
      "id": "cocoa-milkshake-crafting",
      "itemId": "cocoa-milkshake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "grape-milkshake": [
    {
      "id": "grape-milkshake-crafting",
      "itemId": "grape-milkshake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "mandarin-milkshake": [
    {
      "id": "mandarin-milkshake-crafting",
      "itemId": "mandarin-milkshake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "matcha-milkshake": [
    {
      "id": "matcha-milkshake-crafting",
      "itemId": "matcha-milkshake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "mellow-black-tea": [
    {
      "id": "mellow-black-tea-crafting",
      "itemId": "mellow-black-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "mellow-milk-tea": [
    {
      "id": "mellow-milk-tea-crafting",
      "itemId": "mellow-milk-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "milkshake": [
    {
      "id": "milkshake-crafting",
      "itemId": "milkshake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "pineapple-milkshake": [
    {
      "id": "pineapple-milkshake-crafting",
      "itemId": "pineapple-milkshake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "raspberry-milkshake": [
    {
      "id": "raspberry-milkshake-crafting",
      "itemId": "raspberry-milkshake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "strawberry-milkshake": [
    {
      "id": "strawberry-milkshake-crafting",
      "itemId": "strawberry-milkshake",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "daisy-tea": [
    {
      "id": "daisy-tea-crafting",
      "itemId": "daisy-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "exquisite-afternoon-tea": [
    {
      "id": "exquisite-afternoon-tea-crafting",
      "itemId": "exquisite-afternoon-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "green-milk-tea": [
    {
      "id": "green-milk-tea-crafting",
      "itemId": "green-milk-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "green-tea": [
    {
      "id": "green-tea-crafting",
      "itemId": "green-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "matcha-green-milk-tea": [
    {
      "id": "matcha-green-milk-tea-crafting",
      "itemId": "matcha-green-milk-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "rose-tea": [
    {
      "id": "rose-tea-crafting",
      "itemId": "rose-tea",
      "method": "CRAFTING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": [],
      "seasons": [],
      "shadowSize": null,
      "notes": "Cooking recipe entry required."
    }
  ],
  "blue-brick-sparrow": [
    {
      "id": "blue-brick-sparrow-birdwatching",
      "itemId": "blue-brick-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Onsen"
      ],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "purple-brick-sparrow": [
    {
      "id": "purple-brick-sparrow-birdwatching",
      "itemId": "purple-brick-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Ruins"
      ],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "colorful-brick-sparrow": [
    {
      "id": "colorful-brick-sparrow-birdwatching",
      "itemId": "colorful-brick-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Block Bird Special Event"
      ],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "pink-brick-sparrow": [
    {
      "id": "pink-brick-sparrow-birdwatching",
      "itemId": "pink-brick-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Stone Cliff"
      ],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "green-brick-sparrow": [
    {
      "id": "green-brick-sparrow-birdwatching",
      "itemId": "green-brick-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Crater Lake"
      ],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "blue-suit-dove": [
    {
      "id": "blue-suit-dove-birdwatching",
      "itemId": "blue-suit-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Spirit-Oak Pine Forest",
        "[EVENT] Actor Dove"
      ],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "gray-suit-dove": [
    {
      "id": "gray-suit-dove-birdwatching",
      "itemId": "gray-suit-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Deer Tower",
        "[EVENT] Actor Dove"
      ],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "striped-suit-dove": [
    {
      "id": "striped-suit-dove-birdwatching",
      "itemId": "striped-suit-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "[EVENT] Actor Dove"
      ],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "red-suit-dove": [
    {
      "id": "red-suit-dove-birdwatching",
      "itemId": "red-suit-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Forest Island",
        "[EVENT] Actor Dove"
      ],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "green-suit-dove": [
    {
      "id": "green-suit-dove-birdwatching",
      "itemId": "green-suit-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Forest Jump Puzzle",
        "[EVENT] Actor Dove"
      ],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "green-peafowl": [
    {
      "id": "green-peafowl-birdwatching",
      "itemId": "green-peafowl",
      "method": "BIRDWATCHING",
      "requiredLevel": 9,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "[EVENT] Nest of Hundreds"
      ],
      "isEventOnly": true,
      "eventKey": "nest-of-hundreds",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "white-peafowl": [
    {
      "id": "white-peafowl-birdwatching",
      "itemId": "white-peafowl",
      "method": "BIRDWATCHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "[EVENT] Nest of Hundreds"
      ],
      "isEventOnly": true,
      "eventKey": "nest-of-hundreds",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "black-peafowl": [
    {
      "id": "black-peafowl-birdwatching",
      "itemId": "black-peafowl",
      "method": "BIRDWATCHING",
      "requiredLevel": 13,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "[EVENT] Nest of Hundreds"
      ],
      "isEventOnly": true,
      "eventKey": "nest-of-hundreds",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "baikal-teal": [
    {
      "id": "baikal-teal-birdwatching",
      "itemId": "baikal-teal",
      "method": "BIRDWATCHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Onsen Mountain Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "inca-tern": [
    {
      "id": "inca-tern-birdwatching",
      "itemId": "inca-tern",
      "method": "BIRDWATCHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Old Sea"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "chestnut-cheeked-starling": [
    {
      "id": "chestnut-cheeked-starling-birdwatching",
      "itemId": "chestnut-cheeked-starling",
      "method": "BIRDWATCHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Windmill Flower Field"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "blue-headed-quail-dove": [
    {
      "id": "blue-headed-quail-dove-birdwatching",
      "itemId": "blue-headed-quail-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Suburbs"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "snowy-owl": [
    {
      "id": "snowy-owl-birdwatching",
      "itemId": "snowy-owl",
      "method": "BIRDWATCHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Spirit-Oak Pine Forest"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "red-browed-finch": [
    {
      "id": "red-browed-finch-birdwatching",
      "itemId": "red-browed-finch",
      "method": "BIRDWATCHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Crater Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "atlantic-puffin": [
    {
      "id": "atlantic-puffin-birdwatching",
      "itemId": "atlantic-puffin",
      "method": "BIRDWATCHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Whale Sea"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "blue-footed-booby": [
    {
      "id": "blue-footed-booby-birdwatching",
      "itemId": "blue-footed-booby",
      "method": "BIRDWATCHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Zephyr Sea"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "whooper-swan": [
    {
      "id": "whooper-swan-birdwatching",
      "itemId": "whooper-swan",
      "method": "BIRDWATCHING",
      "requiredLevel": 13,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Suburban Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "black-swan": [
    {
      "id": "black-swan-birdwatching",
      "itemId": "black-swan",
      "method": "BIRDWATCHING",
      "requiredLevel": 13,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Suburban Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "black-stork": [
    {
      "id": "black-stork-birdwatching",
      "itemId": "black-stork",
      "method": "BIRDWATCHING",
      "requiredLevel": 14,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Meadow Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "spectacled-owl": [
    {
      "id": "spectacled-owl-birdwatching",
      "itemId": "spectacled-owl",
      "method": "BIRDWATCHING",
      "requiredLevel": 14,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Forest Jump Puzzle"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "director-common-octopus-with-patterned-hat": [
    {
      "id": "director-common-octopus-with-patterned-hat-fishing",
      "itemId": "director-common-octopus-with-patterned-hat",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "[EVENT] Octo Entertainment"
      ],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "LARGE",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        3829,
        2843,
        1939,
        1163,
        226
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "asian-arowana": [
    {
      "id": "asian-arowana-fishing",
      "itemId": "asian-arowana",
      "method": "FISHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Meadow Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "SMALL",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "blackspot-sergeant": [
    {
      "id": "blackspot-sergeant-fishing",
      "itemId": "blackspot-sergeant",
      "method": "FISHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Zephyr Sea"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": "MEDIUM",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "lionhead": [
    {
      "id": "lionhead-fishing",
      "itemId": "lionhead",
      "method": "FISHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Onsen Mountain Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "SMALL",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        500,
        1000
      ]
    }
  ],
  "whale-shark": [
    {
      "id": "whale-shark-fishing",
      "itemId": "whale-shark",
      "method": "FISHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "[EVENT] Sea Fishing"
      ],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "SUNNY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "GOLDEN",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "mahi-mahi": [
    {
      "id": "mahi-mahi-fishing",
      "itemId": "mahi-mahi",
      "method": "FISHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Old Sea"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY"
      ],
      "seasons": [],
      "shadowSize": "LARGE",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "moon-jelly": [
    {
      "id": "moon-jelly-fishing",
      "itemId": "moon-jelly",
      "method": "FISHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "[EVENT] Sea Fishing"
      ],
      "isEventOnly": true,
      "eventKey": "sea-fishing",
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "GOLDEN",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "angelfish": [
    {
      "id": "angelfish-fishing",
      "itemId": "angelfish",
      "method": "FISHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Suburban Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "MEDIUM",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "pink-betta": [
    {
      "id": "pink-betta-fishing",
      "itemId": "pink-betta",
      "method": "FISHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Forest Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": "SMALL",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        500,
        1000
      ]
    }
  ],
  "green-sea-turtle": [
    {
      "id": "green-sea-turtle-fishing",
      "itemId": "green-sea-turtle",
      "method": "FISHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Whale Sea"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": "LARGE",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "white-faced-surgeonfish": [
    {
      "id": "white-faced-surgeonfish-fishing",
      "itemId": "white-faced-surgeonfish",
      "method": "FISHING",
      "requiredLevel": 13,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Old Sea"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "MEDIUM",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        50000,
        200000
      ]
    }
  ],
  "lionfish": [
    {
      "id": "lionfish-fishing",
      "itemId": "lionfish",
      "method": "FISHING",
      "requiredLevel": 13,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Whale Sea"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "MEDIUM",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "blue-and-yellow-wrasse": [
    {
      "id": "blue-and-yellow-wrasse-fishing",
      "itemId": "blue-and-yellow-wrasse",
      "method": "FISHING",
      "requiredLevel": 14,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "East Sea"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": "MEDIUM",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "azure-demoiselle": [
    {
      "id": "azure-demoiselle-fishing",
      "itemId": "azure-demoiselle",
      "method": "FISHING",
      "requiredLevel": 14,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Zephyr Sea"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": "SMALL",
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        50,
        150
      ]
    }
  ],
  "golden-script-supervisor-bumblebee": [
    {
      "id": "golden-script-supervisor-bumblebee-bug-catching",
      "itemId": "golden-script-supervisor-bumblebee",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "[EVENT] Script Supervisor Bee"
      ],
      "isEventOnly": true,
      "eventKey": "dreamlight-cinematics",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4930,
        2800,
        1500,
        450,
        320
      ]
    }
  ],
  "yellow-brick-large-red-damselfly": [
    {
      "id": "yellow-brick-large-red-damselfly-bug-catching",
      "itemId": "yellow-brick-large-red-damselfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Spirit-Oak Pine Forest"
      ],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "blue-brick-large-red-damselfly": [
    {
      "id": "blue-brick-large-red-damselfly-bug-catching",
      "itemId": "blue-brick-large-red-damselfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Deer Tower"
      ],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "purple-brick-large-red-damselfly": [
    {
      "id": "purple-brick-large-red-damselfly-bug-catching",
      "itemId": "purple-brick-large-red-damselfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Forest Island"
      ],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "colorful-brick-large-red-damselfly": [
    {
      "id": "colorful-brick-large-red-damselfly-bug-catching",
      "itemId": "colorful-brick-large-red-damselfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Special Brick Insect Event"
      ],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4930,
        2800,
        1500,
        450,
        320
      ]
    }
  ],
  "pink-brick-large-red-damselfly": [
    {
      "id": "pink-brick-large-red-damselfly-bug-catching",
      "itemId": "pink-brick-large-red-damselfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 1,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Forest Jump Puzzle"
      ],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "atlas-beetle": [
    {
      "id": "atlas-beetle-bug-catching",
      "itemId": "atlas-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Spirit-Oak Pine Forest"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "orchid-mantis": [
    {
      "id": "orchid-mantis-bug-catching",
      "itemId": "orchid-mantis",
      "method": "BUG_CATCHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Ruins"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "queen-alexandra-s-birdwing": [
    {
      "id": "queen-alexandra-s-birdwing-bug-catching",
      "itemId": "queen-alexandra-s-birdwing",
      "method": "BUG_CATCHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Suburban Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "greater-asian-lady-beetle": [
    {
      "id": "greater-asian-lady-beetle-bug-catching",
      "itemId": "greater-asian-lady-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 11,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Whale Mountain"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "goliath-beetle": [
    {
      "id": "goliath-beetle-bug-catching",
      "itemId": "goliath-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Deer Tower"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "red-milkweed-locust": [
    {
      "id": "red-milkweed-locust-bug-catching",
      "itemId": "red-milkweed-locust",
      "method": "BUG_CATCHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Onsen Mountain Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "flamer-skimmer": [
    {
      "id": "flamer-skimmer-bug-catching",
      "itemId": "flamer-skimmer",
      "method": "BUG_CATCHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Meadow Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page."
    }
  ],
  "purple-spotted-swallowtail": [
    {
      "id": "purple-spotted-swallowtail-bug-catching",
      "itemId": "purple-spotted-swallowtail",
      "method": "BUG_CATCHING",
      "requiredLevel": 12,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Windmill Flower Field"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "scarce-morpho": [
    {
      "id": "scarce-morpho-bug-catching",
      "itemId": "scarce-morpho",
      "method": "BUG_CATCHING",
      "requiredLevel": 13,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Crater Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "green-metalwing": [
    {
      "id": "green-metalwing-bug-catching",
      "itemId": "green-metalwing",
      "method": "BUG_CATCHING",
      "requiredLevel": 13,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Suburban Lake"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "green-snail": [
    {
      "id": "green-snail-bug-catching",
      "itemId": "green-snail",
      "method": "BUG_CATCHING",
      "requiredLevel": 14,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Forest Island"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "glasswing-butterfly": [
    {
      "id": "glasswing-butterfly-bug-catching",
      "itemId": "glasswing-butterfly",
      "method": "BUG_CATCHING",
      "requiredLevel": 14,
      "habitat": null,
      "locationIds": [],
      "areaIds": [
        "Whale Mountain"
      ],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK"
      ],
      "seasons": [],
      "shadowSize": null,
      "notes": "Details captured from Heartodex list view where visible; refine weather/time/location from item detail page.",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "blue-brick-clownfish": [
    {
      "id": "blue-brick-clownfish-fishing",
      "itemId": "blue-brick-clownfish",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "SMALL",
      "notes": "Confirmed on Heartodex fish list as Modular Streets LV.1 Brick Clownfish variant.",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "colorful-brick-clownfish": [
    {
      "id": "colorful-brick-clownfish-fishing",
      "itemId": "colorful-brick-clownfish",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "Special Brick Fish Event",
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "SMALL",
      "notes": "Confirmed on Heartodex fish list as Modular Streets LV.1 Brick Clownfish variant."
    }
  ],
  "purple-brick-clownfish": [
    {
      "id": "purple-brick-clownfish-fishing",
      "itemId": "purple-brick-clownfish",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "SMALL",
      "notes": "Confirmed on Heartodex fish list as Modular Streets LV.1 Brick Clownfish variant.",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "red-brick-clownfish": [
    {
      "id": "red-brick-clownfish-fishing",
      "itemId": "red-brick-clownfish",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "SMALL",
      "notes": "Confirmed on Heartodex fish list as Modular Streets LV.1 Brick Clownfish variant.",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "green-brick-clownfish": [
    {
      "id": "green-brick-clownfish-fishing",
      "itemId": "green-brick-clownfish",
      "method": "FISHING",
      "requiredLevel": 1,
      "habitat": "East Sea",
      "locationIds": [
        "east-sea"
      ],
      "areaIds": [],
      "isEventOnly": true,
      "eventKey": "modular-streets",
      "weather": [
        "RAINBOW",
        "SUNNY",
        "RAINY"
      ],
      "timeOfDay": [
        "DAY",
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "seasons": [],
      "shadowSize": "SMALL",
      "notes": "Confirmed on Heartodex fish list as Modular Streets LV.1 Brick Clownfish variant.",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "agrias-butterfly": [
    {
      "id": "agrias-butterfly-obtain",
      "itemId": "agrias-butterfly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "apple-hermit-crab": [
    {
      "id": "apple-hermit-crab-obtain",
      "itemId": "apple-hermit-crab",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3688,
        2843,
        1939,
        1163,
        367
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "audouin-s-gull": [
    {
      "id": "audouin-s-gull-obtain",
      "itemId": "audouin-s-gull",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "balloon-morpho": [
    {
      "id": "balloon-morpho-obtain",
      "itemId": "balloon-morpho",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4973,
        2800,
        1500,
        450,
        277
      ]
    }
  ],
  "balloon-nymphalidae": [
    {
      "id": "balloon-nymphalidae-obtain",
      "itemId": "balloon-nymphalidae",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4973,
        2800,
        1500,
        450,
        277
      ]
    }
  ],
  "balloon-swallowtail": [
    {
      "id": "balloon-swallowtail-obtain",
      "itemId": "balloon-swallowtail",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4973,
        2800,
        1500,
        450,
        277
      ]
    }
  ],
  "bandage-fish": [
    {
      "id": "bandage-fish-obtain",
      "itemId": "bandage-fish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        3743,
        2647,
        1805,
        1083,
        722
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "black-turkey": [
    {
      "id": "black-turkey-obtain",
      "itemId": "black-turkey",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "blue-camping-sparrow": [
    {
      "id": "blue-camping-sparrow-obtain",
      "itemId": "blue-camping-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "blue-clockwork-sparrow": [
    {
      "id": "blue-clockwork-sparrow-obtain",
      "itemId": "blue-clockwork-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "blue-dung-beetle": [
    {
      "id": "blue-dung-beetle-obtain",
      "itemId": "blue-dung-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "blue-floating-dust-bug": [
    {
      "id": "blue-floating-dust-bug-obtain",
      "itemId": "blue-floating-dust-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4983,
        2800,
        1500,
        450,
        267
      ]
    }
  ],
  "blue-hat-stock-dove": [
    {
      "id": "blue-hat-stock-dove-obtain",
      "itemId": "blue-hat-stock-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "blue-jello-fish": [
    {
      "id": "blue-jello-fish-obtain",
      "itemId": "blue-jello-fish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3350,
        2843,
        1939,
        1163,
        705
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "blue-light-firefly": [
    {
      "id": "blue-light-firefly-obtain",
      "itemId": "blue-light-firefly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5028,
        2800,
        1500,
        450,
        222
      ]
    }
  ],
  "blue-milkweed-beetle": [
    {
      "id": "blue-milkweed-beetle-obtain",
      "itemId": "blue-milkweed-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "blue-red-betta": [
    {
      "id": "blue-red-betta-obtain",
      "itemId": "blue-red-betta",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        2651,
        2669,
        2080,
        1560,
        1040
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "blue-starry-stock-dove": [
    {
      "id": "blue-starry-stock-dove-obtain",
      "itemId": "blue-starry-stock-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "blue-starry-swan": [
    {
      "id": "blue-starry-swan-obtain",
      "itemId": "blue-starry-swan",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "blueberry-hermit-crab": [
    {
      "id": "blueberry-hermit-crab-obtain",
      "itemId": "blueberry-hermit-crab",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3688,
        2843,
        1939,
        1163,
        367
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "bourbon-red-turkey": [
    {
      "id": "bourbon-red-turkey-obtain",
      "itemId": "bourbon-red-turkey",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "brown-camping-sparrow": [
    {
      "id": "brown-camping-sparrow-obtain",
      "itemId": "brown-camping-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "brown-clockwork-sparrow": [
    {
      "id": "brown-clockwork-sparrow-obtain",
      "itemId": "brown-clockwork-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "brown-hat-stock-dove": [
    {
      "id": "brown-hat-stock-dove-obtain",
      "itemId": "brown-hat-stock-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "brown-sauna-hat-sea-turtle": [
    {
      "id": "brown-sauna-hat-sea-turtle-obtain",
      "itemId": "brown-sauna-hat-sea-turtle",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        1788,
        3675,
        2505,
        1503,
        529
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "candy-corn-fish": [
    {
      "id": "candy-corn-fish-obtain",
      "itemId": "candy-corn-fish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4652,
        2262,
        1543,
        926,
        617
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "clockwork-frog": [
    {
      "id": "clockwork-frog-obtain",
      "itemId": "clockwork-frog",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        2519,
        3198,
        2181,
        1309,
        793
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "coal-bug": [
    {
      "id": "coal-bug-obtain",
      "itemId": "coal-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "crawling-firecracker-bug": [
    {
      "id": "crawling-firecracker-bug-obtain",
      "itemId": "crawling-firecracker-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5084,
        2800,
        1500,
        450,
        166
      ]
    }
  ],
  "dragonfruit-hermit-crab": [
    {
      "id": "dragonfruit-hermit-crab-obtain",
      "itemId": "dragonfruit-hermit-crab",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3688,
        2843,
        1939,
        1163,
        367
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "eastern-lubber-grasshopper": [
    {
      "id": "eastern-lubber-grasshopper-obtain",
      "itemId": "eastern-lubber-grasshopper",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": []
    }
  ],
  "firefly-squid": [
    {
      "id": "firefly-squid-obtain",
      "itemId": "firefly-squid",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4192,
        2622,
        1788,
        1073,
        325
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "flame-skimmer": [
    {
      "id": "flame-skimmer-obtain",
      "itemId": "flame-skimmer",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY"
      ],
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ]
    }
  ],
  "flatback-turtle": [
    {
      "id": "flatback-turtle-obtain",
      "itemId": "flatback-turtle",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4192,
        2622,
        1788,
        1073,
        325
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "flying-firecracker-bug": [
    {
      "id": "flying-firecracker-bug-obtain",
      "itemId": "flying-firecracker-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5084,
        2800,
        1500,
        450,
        166
      ]
    }
  ],
  "ghost-frog": [
    {
      "id": "ghost-frog-obtain",
      "itemId": "ghost-frog",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        3743,
        2647,
        1805,
        1083,
        722
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "gin-matsuba-koi": [
    {
      "id": "gin-matsuba-koi-obtain",
      "itemId": "gin-matsuba-koi",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        2477,
        3183,
        2170,
        1302,
        868
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "gold-bug": [
    {
      "id": "gold-bug-obtain",
      "itemId": "gold-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4930,
        2800,
        1500,
        450,
        320
      ]
    }
  ],
  "golden-clockwork-ladybug": [
    {
      "id": "golden-clockwork-ladybug-obtain",
      "itemId": "golden-clockwork-ladybug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4362,
        2800,
        1500,
        450,
        888
      ]
    }
  ],
  "golden-dung-beetle": [
    {
      "id": "golden-dung-beetle-obtain",
      "itemId": "golden-dung-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4930,
        2800,
        1500,
        450,
        320
      ]
    }
  ],
  "golden-koi": [
    {
      "id": "golden-koi-obtain",
      "itemId": "golden-koi",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        1982,
        3392,
        2313,
        1388,
        925
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "golden-pheasant": [
    {
      "id": "golden-pheasant-obtain",
      "itemId": "golden-pheasant",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "gray-bouncy-dust-insect": [
    {
      "id": "gray-bouncy-dust-insect-obtain",
      "itemId": "gray-bouncy-dust-insect",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        2800,
        1500,
        450,
        250
      ]
    }
  ],
  "gray-camping-sparrow": [
    {
      "id": "gray-camping-sparrow-obtain",
      "itemId": "gray-camping-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "gray-clockwork-sparrow": [
    {
      "id": "gray-clockwork-sparrow-obtain",
      "itemId": "gray-clockwork-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "great-black-firefly": [
    {
      "id": "great-black-firefly-obtain",
      "itemId": "great-black-firefly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "green-bath-towel-mako-shark": [
    {
      "id": "green-bath-towel-mako-shark-obtain",
      "itemId": "green-bath-towel-mako-shark",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "green-bouncy-dust-bug": [
    {
      "id": "green-bouncy-dust-bug-obtain",
      "itemId": "green-bouncy-dust-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5000,
        2800,
        1500,
        450,
        250
      ]
    }
  ],
  "green-camping-sparrow": [
    {
      "id": "green-camping-sparrow-obtain",
      "itemId": "green-camping-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "green-dung-beetle": [
    {
      "id": "green-dung-beetle-obtain",
      "itemId": "green-dung-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "green-flower-chafer": [
    {
      "id": "green-flower-chafer-obtain",
      "itemId": "green-flower-chafer",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "green-hat-stock-dove": [
    {
      "id": "green-hat-stock-dove-obtain",
      "itemId": "green-hat-stock-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "green-jello-fish": [
    {
      "id": "green-jello-fish-obtain",
      "itemId": "green-jello-fish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3350,
        2843,
        1939,
        1163,
        705
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "green-light-firefly": [
    {
      "id": "green-light-firefly-obtain",
      "itemId": "green-light-firefly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5028,
        2800,
        1500,
        450,
        222
      ]
    }
  ],
  "green-light-sea-star": [
    {
      "id": "green-light-sea-star-obtain",
      "itemId": "green-light-sea-star",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        3762,
        2843,
        1939,
        1163,
        293
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "green-starry-stock-dove": [
    {
      "id": "green-starry-stock-dove-obtain",
      "itemId": "green-starry-stock-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "green-starry-swan": [
    {
      "id": "green-starry-swan-obtain",
      "itemId": "green-starry-swan",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "grey-mantled-albatross": [
    {
      "id": "grey-mantled-albatross-obtain",
      "itemId": "grey-mantled-albatross",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "hanging-firecracker-bug": [
    {
      "id": "hanging-firecracker-bug-obtain",
      "itemId": "hanging-firecracker-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5028,
        2800,
        1500,
        450,
        222
      ]
    }
  ],
  "ice-bug": [
    {
      "id": "ice-bug-obtain",
      "itemId": "ice-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "indigo-hanging-dust-bug": [
    {
      "id": "indigo-hanging-dust-bug-obtain",
      "itemId": "indigo-hanging-dust-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4869,
        2800,
        1500,
        450,
        381
      ]
    }
  ],
  "indigo-jello-fish": [
    {
      "id": "indigo-jello-fish-obtain",
      "itemId": "indigo-jello-fish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3350,
        2843,
        1939,
        1163,
        705
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "inflatable-mallard": [
    {
      "id": "inflatable-mallard-obtain",
      "itemId": "inflatable-mallard",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "inflatable-ruddy-shelduck": [
    {
      "id": "inflatable-ruddy-shelduck-obtain",
      "itemId": "inflatable-ruddy-shelduck",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "inflatable-smew": [
    {
      "id": "inflatable-smew-obtain",
      "itemId": "inflatable-smew",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "inflatable-wigeon": [
    {
      "id": "inflatable-wigeon-obtain",
      "itemId": "inflatable-wigeon",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "jumping-firecracker-bug": [
    {
      "id": "jumping-firecracker-bug-obtain",
      "itemId": "jumping-firecracker-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4695,
        2800,
        1500,
        450,
        555
      ]
    }
  ],
  "kissing-fish": [
    {
      "id": "kissing-fish-obtain",
      "itemId": "kissing-fish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        2651,
        2669,
        2080,
        1560,
        1040
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "koi": [
    {
      "id": "koi-obtain",
      "itemId": "koi",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        2477,
        3183,
        2170,
        1302,
        868
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "lady-amherst-s-pheasant": [
    {
      "id": "lady-amherst-s-pheasant-obtain",
      "itemId": "lady-amherst-s-pheasant",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "little-egret": [
    {
      "id": "little-egret-obtain",
      "itemId": "little-egret",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "lychee-shieldbug": [
    {
      "id": "lychee-shieldbug-obtain",
      "itemId": "lychee-shieldbug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [],
      "timeOfDay": []
    }
  ],
  "mandarin-duck": [
    {
      "id": "mandarin-duck-obtain",
      "itemId": "mandarin-duck",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "mandarin-fish": [
    {
      "id": "mandarin-fish-obtain",
      "itemId": "mandarin-fish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4192,
        2622,
        1788,
        1073,
        325
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "mandarin-hermit-crab": [
    {
      "id": "mandarin-hermit-crab-obtain",
      "itemId": "mandarin-hermit-crab",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3688,
        2843,
        1939,
        1163,
        367
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "morpho-luna": [
    {
      "id": "morpho-luna-obtain",
      "itemId": "morpho-luna",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4930,
        2800,
        1500,
        450,
        320
      ]
    }
  ],
  "ocellated-turkey": [
    {
      "id": "ocellated-turkey-obtain",
      "itemId": "ocellated-turkey",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "olive-ridley-turtle": [
    {
      "id": "olive-ridley-turtle-obtain",
      "itemId": "olive-ridley-turtle",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4192,
        2622,
        1788,
        1073,
        325
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "orange-camping-sparrow": [
    {
      "id": "orange-camping-sparrow-obtain",
      "itemId": "orange-camping-sparrow",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "orange-jello-fish": [
    {
      "id": "orange-jello-fish-obtain",
      "itemId": "orange-jello-fish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3350,
        2843,
        1939,
        1163,
        705
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "oriental-magpie": [
    {
      "id": "oriental-magpie-obtain",
      "itemId": "oriental-magpie",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "permit": [
    {
      "id": "permit-obtain",
      "itemId": "permit",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4500,
        2000,
        1500,
        1200,
        800
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "pied-falconet": [
    {
      "id": "pied-falconet-obtain",
      "itemId": "pied-falconet",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "pied-kingfisher": [
    {
      "id": "pied-kingfisher-obtain",
      "itemId": "pied-kingfisher",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "pink-atlantic-salmon": [
    {
      "id": "pink-atlantic-salmon-obtain",
      "itemId": "pink-atlantic-salmon",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "pink-hanging-dust-bug": [
    {
      "id": "pink-hanging-dust-bug-obtain",
      "itemId": "pink-hanging-dust-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4869,
        2800,
        1500,
        450,
        381
      ]
    }
  ],
  "pink-hat-stock-dove": [
    {
      "id": "pink-hat-stock-dove-obtain",
      "itemId": "pink-hat-stock-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "pink-king-crab": [
    {
      "id": "pink-king-crab-obtain",
      "itemId": "pink-king-crab",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "pink-light-firefly": [
    {
      "id": "pink-light-firefly-obtain",
      "itemId": "pink-light-firefly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5028,
        2800,
        1500,
        450,
        222
      ]
    }
  ],
  "pink-necked-firefly": [
    {
      "id": "pink-necked-firefly-obtain",
      "itemId": "pink-necked-firefly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "pink-seahorse": [
    {
      "id": "pink-seahorse-obtain",
      "itemId": "pink-seahorse",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        150,
        300
      ]
    }
  ],
  "pink-shortfin-mako-shark": [
    {
      "id": "pink-shortfin-mako-shark-obtain",
      "itemId": "pink-shortfin-mako-shark",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "pink-swordfish": [
    {
      "id": "pink-swordfish-obtain",
      "itemId": "pink-swordfish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "pomarine-skua": [
    {
      "id": "pomarine-skua-obtain",
      "itemId": "pomarine-skua",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "psionic-indian-fritillary": [
    {
      "id": "psionic-indian-fritillary-obtain",
      "itemId": "psionic-indian-fritillary",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5084,
        2800,
        1500,
        450,
        166
      ]
    }
  ],
  "psionic-luna-moth": [
    {
      "id": "psionic-luna-moth-obtain",
      "itemId": "psionic-luna-moth",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5084,
        2800,
        1500,
        450,
        166
      ]
    }
  ],
  "psionic-queen-alexandra-s-birdwing": [
    {
      "id": "psionic-queen-alexandra-s-birdwing-obtain",
      "itemId": "psionic-queen-alexandra-s-birdwing",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "psionic-rimmed-window-firefly": [
    {
      "id": "psionic-rimmed-window-firefly-obtain",
      "itemId": "psionic-rimmed-window-firefly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5084,
        2800,
        1500,
        450,
        166
      ]
    }
  ],
  "purple-dung-beetle": [
    {
      "id": "purple-dung-beetle-obtain",
      "itemId": "purple-dung-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "purple-floating-dust-bug": [
    {
      "id": "purple-floating-dust-bug-obtain",
      "itemId": "purple-floating-dust-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4983,
        2800,
        1500,
        450,
        267
      ]
    }
  ],
  "purple-jello-fish": [
    {
      "id": "purple-jello-fish-obtain",
      "itemId": "purple-jello-fish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3350,
        2843,
        1939,
        1163,
        705
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "purple-light-firefly": [
    {
      "id": "purple-light-firefly-obtain",
      "itemId": "purple-light-firefly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5028,
        2800,
        1500,
        450,
        222
      ]
    }
  ],
  "purple-light-sea-star": [
    {
      "id": "purple-light-sea-star-obtain",
      "itemId": "purple-light-sea-star",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        3725,
        2843,
        1939,
        1163,
        330
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "purple-starry-stock-dove": [
    {
      "id": "purple-starry-stock-dove-obtain",
      "itemId": "purple-starry-stock-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "purple-starry-swan": [
    {
      "id": "purple-starry-swan-obtain",
      "itemId": "purple-starry-swan",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "rajah-brooke-s-birdwing": [
    {
      "id": "rajah-brooke-s-birdwing-obtain",
      "itemId": "rajah-brooke-s-birdwing",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "raspberry-hermit-crab": [
    {
      "id": "raspberry-hermit-crab-obtain",
      "itemId": "raspberry-hermit-crab",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3688,
        2843,
        1939,
        1163,
        367
      ],
      "weightRange": [
        1000,
        3000
      ]
    }
  ],
  "red-clockwork-ladybug": [
    {
      "id": "red-clockwork-ladybug-obtain",
      "itemId": "red-clockwork-ladybug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5028,
        2800,
        1500,
        450,
        222
      ]
    }
  ],
  "red-crowned-crane": [
    {
      "id": "red-crowned-crane-obtain",
      "itemId": "red-crowned-crane",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "red-dung-beetle": [
    {
      "id": "red-dung-beetle-obtain",
      "itemId": "red-dung-beetle",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "red-jello-fish": [
    {
      "id": "red-jello-fish-obtain",
      "itemId": "red-jello-fish",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        3350,
        2843,
        1939,
        1163,
        705
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "red-koi": [
    {
      "id": "red-koi-obtain",
      "itemId": "red-koi",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        2477,
        3183,
        2170,
        1302,
        868
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "rimmed-window-firefly": [
    {
      "id": "rimmed-window-firefly-obtain",
      "itemId": "rimmed-window-firefly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "rock-bug": [
    {
      "id": "rock-bug-obtain",
      "itemId": "rock-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "roseate-spoonbill": [
    {
      "id": "roseate-spoonbill-obtain",
      "itemId": "roseate-spoonbill",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "royal-palm-turkey": [
    {
      "id": "royal-palm-turkey-obtain",
      "itemId": "royal-palm-turkey",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "sea-slug": [
    {
      "id": "sea-slug-obtain",
      "itemId": "sea-slug",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "SMALL",
      "starWeights": [
        5284,
        2129,
        1452,
        871,
        264
      ],
      "weightRange": [
        20,
        70
      ]
    }
  ],
  "snow-bug": [
    {
      "id": "snow-bug-obtain",
      "itemId": "snow-bug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "snowy-window-firefly": [
    {
      "id": "snowy-window-firefly-obtain",
      "itemId": "snowy-window-firefly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4950,
        2800,
        1500,
        450,
        300
      ]
    }
  ],
  "spectral-octopus": [
    {
      "id": "spectral-octopus-obtain",
      "itemId": "spectral-octopus",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        3309,
        2831,
        1930,
        1158,
        772
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "striped-bath-towel-mako-shark": [
    {
      "id": "striped-bath-towel-mako-shark-obtain",
      "itemId": "striped-bath-towel-mako-shark",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        3526,
        2843,
        1939,
        1163,
        529
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "striped-sauna-hat-sea-turtle": [
    {
      "id": "striped-sauna-hat-sea-turtle-obtain",
      "itemId": "striped-sauna-hat-sea-turtle",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "sulkowsky-s-morpho": [
    {
      "id": "sulkowsky-s-morpho-obtain",
      "itemId": "sulkowsky-s-morpho",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4750,
        2600,
        1500,
        750,
        400
      ]
    }
  ],
  "turkey": [
    {
      "id": "turkey-obtain",
      "itemId": "turkey",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "wandering-albatross": [
    {
      "id": "wandering-albatross-obtain",
      "itemId": "wandering-albatross",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "white-banded-erebus-moth": [
    {
      "id": "white-banded-erebus-moth-obtain",
      "itemId": "white-banded-erebus-moth",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        5019,
        2800,
        1500,
        450,
        231
      ]
    }
  ],
  "white-clockwork-ladybug": [
    {
      "id": "white-clockwork-ladybug-obtain",
      "itemId": "white-clockwork-ladybug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4991,
        2800,
        1500,
        450,
        259
      ]
    }
  ],
  "white-faced-storm-petrel": [
    {
      "id": "white-faced-storm-petrel-obtain",
      "itemId": "white-faced-storm-petrel",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "white-hat-stock-dove": [
    {
      "id": "white-hat-stock-dove-obtain",
      "itemId": "white-hat-stock-dove",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "white-sauna-hat-sea-turtle": [
    {
      "id": "white-sauna-hat-sea-turtle-obtain",
      "itemId": "white-sauna-hat-sea-turtle",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "MEDIUM",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        2000,
        5000
      ]
    }
  ],
  "white-spoonbill": [
    {
      "id": "white-spoonbill-obtain",
      "itemId": "white-spoonbill",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "white-winged-tern": [
    {
      "id": "white-winged-tern-obtain",
      "itemId": "white-winged-tern",
      "method": "BIRDWATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ]
    }
  ],
  "yellow-bath-towel-mako-shark": [
    {
      "id": "yellow-bath-towel-mako-shark-obtain",
      "itemId": "yellow-bath-towel-mako-shark",
      "method": "FISHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "shadowSize": "LARGE",
      "starWeights": [
        3844,
        2843,
        1939,
        1163,
        211
      ],
      "weightRange": [
        80000,
        150000
      ]
    }
  ],
  "yellow-clockwork-ladybug": [
    {
      "id": "yellow-clockwork-ladybug-obtain",
      "itemId": "yellow-clockwork-ladybug",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4991,
        2800,
        1500,
        450,
        259
      ]
    }
  ],
  "yellow-light-firefly": [
    {
      "id": "yellow-light-firefly-obtain",
      "itemId": "yellow-light-firefly",
      "method": "BUG_CATCHING",
      "requiredLevel": null,
      "habitat": null,
      "locationIds": [],
      "areaIds": [],
      "isEventOnly": false,
      "eventKey": null,
      "weather": [
        "SUNNY",
        "RAINY",
        "RAINBOW"
      ],
      "timeOfDay": [
        "DAWN",
        "DAY",
        "DUSK",
        "NIGHT"
      ],
      "starWeights": [
        4695,
        2800,
        1500,
        450,
        555
      ]
    }
  ]
};
